var items = {
  "block.minecraft.acacia_button": "Botón de mimoça",
  "block.minecraft.acacia_door": "Puerta de mimoça",
  "block.minecraft.acacia_fence": "Berha de mimoça",
  "block.minecraft.acacia_fence_gate": "Cançela de mimoça",
  "block.minecraft.acacia_hanging_sign": "Letrero corgante de mimoça",
  "block.minecraft.acacia_leaves": "Ohâ de mimoça",
  "block.minecraft.acacia_log": "Tronco de mimoça",
  "block.minecraft.acacia_planks": "Tablonê de mimoça",
  "block.minecraft.acacia_pressure_plate": "Placa de preçión de mimoça",
  "block.minecraft.acacia_sapling": "Brote de mimoça",
  "block.minecraft.acacia_shelf": "Êttante de acaçia",
  "block.minecraft.acacia_sign": "Letrero de mimoça",
  "block.minecraft.acacia_slab": "Bardoça de mimoça",
  "block.minecraft.acacia_stairs": "Êccalerâ de mimoça",
  "block.minecraft.acacia_trapdoor": "Trampiya de mimoça",
  "block.minecraft.acacia_wall_hanging_sign": "Letrero corgante de mimoça en paré",
  "block.minecraft.acacia_wall_sign": "Letrero de mimoça en paré",
  "block.minecraft.acacia_wood": "Leño de mimoça",
  "block.minecraft.activator_rail": "Raîh âttibadôh",
  "block.minecraft.air": "Aire",
  "block.minecraft.allium": "Allium",
  "block.minecraft.amethyst_block": "Bloque d'ametîtta",
  "block.minecraft.amethyst_cluster": "Cúmulo d'ametîtta",
  "block.minecraft.ancient_debris": "Detritô ançêttralê",
  "block.minecraft.andesite": "Andeçita",
  "block.minecraft.andesite_slab": "Bardoça d'andeçita",
  "block.minecraft.andesite_stairs": "Êccalerâ d'andeçita",
  "block.minecraft.andesite_wall": "Muro d'andeçita",
  "block.minecraft.anvil": "Yunque",
  "block.minecraft.attached_melon_stem": "Tayo d'açendía unío",
  "block.minecraft.attached_pumpkin_stem": "Tayo de calabaça unío",
  "block.minecraft.azalea": "Açalea",
  "block.minecraft.azalea_leaves": "Ohâ d'açalea",
  "block.minecraft.azure_bluet": "Rubiáçea",
  "block.minecraft.bamboo": "Bambú",
  "block.minecraft.bamboo_block": "Bloque de bambú",
  "block.minecraft.bamboo_button": "Botón de bambú",
  "block.minecraft.bamboo_door": "Puerta de bambú",
  "block.minecraft.bamboo_fence": "Berha de bambú",
  "block.minecraft.bamboo_fence_gate": "Cançela de bambú",
  "block.minecraft.bamboo_hanging_sign": "Letrero corgante de bambú",
  "block.minecraft.bamboo_mosaic": "Moçaico de bambú",
  "block.minecraft.bamboo_mosaic_slab": "Bardoça de moçaico de bambú",
  "block.minecraft.bamboo_mosaic_stairs": "Êccalerâ de moçaico de bambú",
  "block.minecraft.bamboo_planks": "Tablonê de bambú",
  "block.minecraft.bamboo_pressure_plate": "Placa de preçión de bambú",
  "block.minecraft.bamboo_sapling": "Brote de bambú",
  "block.minecraft.bamboo_shelf": "Êttante de bambú",
  "block.minecraft.bamboo_sign": "Letrero de bambú",
  "block.minecraft.bamboo_slab": "Bardoça de bambú",
  "block.minecraft.bamboo_stairs": "Êccalerâ de bambú",
  "block.minecraft.bamboo_trapdoor": "Trampiya de bambú",
  "block.minecraft.bamboo_wall_hanging_sign": "Letrero corgante de bambú en paré",
  "block.minecraft.bamboo_wall_sign": "Letrero de bambú en paré",
  "block.minecraft.banner.base.black": "Paño êccuro",
  "block.minecraft.banner.base.blue": "Paño açûh",
  "block.minecraft.banner.base.brown": "Paño marrón",
  "block.minecraft.banner.base.cyan": "Paño çian",
  "block.minecraft.banner.base.gray": "Paño grîh",
  "block.minecraft.banner.base.green": "Paño berde",
  "block.minecraft.banner.base.light_blue": "Paño açûh claro",
  "block.minecraft.banner.base.light_gray": "Paño grîh claro",
  "block.minecraft.banner.base.lime": "Paño lima",
  "block.minecraft.banner.base.magenta": "Paño mahenta",
  "block.minecraft.banner.base.orange": "Paño naranha",
  "block.minecraft.banner.base.pink": "Paño roça",
  "block.minecraft.banner.base.purple": "Paño morao",
  "block.minecraft.banner.base.red": "Paño colorao",
  "block.minecraft.banner.base.white": "Paño blanco",
  "block.minecraft.banner.base.yellow": "Paño amariyo",
  "block.minecraft.banner.border.black": "Bordeao êccuro",
  "block.minecraft.banner.border.blue": "Bordeao açûh",
  "block.minecraft.banner.border.brown": "Bordeao marrón",
  "block.minecraft.banner.border.cyan": "Bordeao çian",
  "block.minecraft.banner.border.gray": "Bordeao grîh",
  "block.minecraft.banner.border.green": "Bordeao berde",
  "block.minecraft.banner.border.light_blue": "Bordeao açûh claro",
  "block.minecraft.banner.border.light_gray": "Bordeao grîh claro",
  "block.minecraft.banner.border.lime": "Bordeao lima",
  "block.minecraft.banner.border.magenta": "Bordeao mahenta",
  "block.minecraft.banner.border.orange": "Bordeao naranha",
  "block.minecraft.banner.border.pink": "Bordeao roça",
  "block.minecraft.banner.border.purple": "Bordeao morao",
  "block.minecraft.banner.border.red": "Bordeao colorao",
  "block.minecraft.banner.border.white": "Bordeao blanco",
  "block.minecraft.banner.border.yellow": "Bordeao amariyo",
  "block.minecraft.banner.bricks.black": "Enladriyao êccuro",
  "block.minecraft.banner.bricks.blue": "Enladriyao açûh",
  "block.minecraft.banner.bricks.brown": "Enladriyao marrón",
  "block.minecraft.banner.bricks.cyan": "Enladriyao çian",
  "block.minecraft.banner.bricks.gray": "Enladriyao grîh",
  "block.minecraft.banner.bricks.green": "Enladriyao berde",
  "block.minecraft.banner.bricks.light_blue": "Enladriyao açûh claro",
  "block.minecraft.banner.bricks.light_gray": "Enladriyao grîh claro",
  "block.minecraft.banner.bricks.lime": "Enladriyao lima",
  "block.minecraft.banner.bricks.magenta": "Enladriyao mahenta",
  "block.minecraft.banner.bricks.orange": "Enladriyao naranha",
  "block.minecraft.banner.bricks.pink": "Enladriyao roça",
  "block.minecraft.banner.bricks.purple": "Enladriyao morao",
  "block.minecraft.banner.bricks.red": "Enladriyao colorao",
  "block.minecraft.banner.bricks.white": "Enladriyao blanco",
  "block.minecraft.banner.bricks.yellow": "Enladriyao amariyo",
  "block.minecraft.banner.circle.black": "Reondêh êccuro",
  "block.minecraft.banner.circle.blue": "Reondêh açûh",
  "block.minecraft.banner.circle.brown": "Reondêh marrón",
  "block.minecraft.banner.circle.cyan": "Reondêh çian",
  "block.minecraft.banner.circle.gray": "Reondêh grîh",
  "block.minecraft.banner.circle.green": "Reondêh berde",
  "block.minecraft.banner.circle.light_blue": "Reondêh açûh claro",
  "block.minecraft.banner.circle.light_gray": "Reondêh grîh claro",
  "block.minecraft.banner.circle.lime": "Reondêh lima",
  "block.minecraft.banner.circle.magenta": "Reondêh mahenta",
  "block.minecraft.banner.circle.orange": "Reondêh naranha",
  "block.minecraft.banner.circle.pink": "Reondêh roça",
  "block.minecraft.banner.circle.purple": "Reondêh morao",
  "block.minecraft.banner.circle.red": "Reondêh colorao",
  "block.minecraft.banner.circle.white": "Reondêh blanco",
  "block.minecraft.banner.circle.yellow": "Reondêh amariyo",
  "block.minecraft.banner.creeper.black": "Êttampao êccuro de creeper",
  "block.minecraft.banner.creeper.blue": "Êttampao açûh de creeper",
  "block.minecraft.banner.creeper.brown": "Êttampao marrón de creeper",
  "block.minecraft.banner.creeper.cyan": "Êttampao çian de creeper",
  "block.minecraft.banner.creeper.gray": "Êttampao grîh de creeper",
  "block.minecraft.banner.creeper.green": "Êttampao berde de creeper",
  "block.minecraft.banner.creeper.light_blue": "Êttampao açûh claro de creeper",
  "block.minecraft.banner.creeper.light_gray": "Êttampao grîh claro de creeper",
  "block.minecraft.banner.creeper.lime": "Êttampao lima de creeper",
  "block.minecraft.banner.creeper.magenta": "Êttampao mahenta de creeper",
  "block.minecraft.banner.creeper.orange": "Êttampao naranha de creeper",
  "block.minecraft.banner.creeper.pink": "Êttampao roça de creeper",
  "block.minecraft.banner.creeper.purple": "Êttampao morao de creeper",
  "block.minecraft.banner.creeper.red": "Êttampao colorao de creeper",
  "block.minecraft.banner.creeper.white": "Êttampao blanco de creeper",
  "block.minecraft.banner.creeper.yellow": "Êttampao amariiyo de creeper",
  "block.minecraft.banner.cross.black": "Âppa êccura",
  "block.minecraft.banner.cross.blue": "Âppa açûh",
  "block.minecraft.banner.cross.brown": "Âppa marrón",
  "block.minecraft.banner.cross.cyan": "Âppa çian",
  "block.minecraft.banner.cross.gray": "Âppa grîh",
  "block.minecraft.banner.cross.green": "Âppa colorá",
  "block.minecraft.banner.cross.light_blue": "Âppa açûh claro",
  "block.minecraft.banner.cross.light_gray": "Âppa grîh claro",
  "block.minecraft.banner.cross.lime": "Âppa lima",
  "block.minecraft.banner.cross.magenta": "Âppa mahenta",
  "block.minecraft.banner.cross.orange": "Âppa naranha",
  "block.minecraft.banner.cross.pink": "Âppa roça",
  "block.minecraft.banner.cross.purple": "Âppa morá",
  "block.minecraft.banner.cross.red": "Âppa colorá",
  "block.minecraft.banner.cross.white": "Âppa blanca",
  "block.minecraft.banner.cross.yellow": "Âppa amariya",
  "block.minecraft.banner.curly_border.black": "Bordeao êccuro dentao",
  "block.minecraft.banner.curly_border.blue": "Bordeao açûh dentao",
  "block.minecraft.banner.curly_border.brown": "Bordeao marrón dentao",
  "block.minecraft.banner.curly_border.cyan": "Bordeao çian dentao",
  "block.minecraft.banner.curly_border.gray": "Bordeao grîh dentao",
  "block.minecraft.banner.curly_border.green": "Bordeao berde dentao",
  "block.minecraft.banner.curly_border.light_blue": "Bordeao açûh claro dentao",
  "block.minecraft.banner.curly_border.light_gray": "Bordeao grîh claro dentao",
  "block.minecraft.banner.curly_border.lime": "Bordeao lima dentao",
  "block.minecraft.banner.curly_border.magenta": "Bordura mahenta dentá",
  "block.minecraft.banner.curly_border.orange": "Bordeao naranha dentao",
  "block.minecraft.banner.curly_border.pink": "Bordeao roça dentao",
  "block.minecraft.banner.curly_border.purple": "Bordeao morao dentao",
  "block.minecraft.banner.curly_border.red": "Bordeao colorao dentao",
  "block.minecraft.banner.curly_border.white": "Bordeao blanco dentao",
  "block.minecraft.banner.curly_border.yellow": "Bordeao amariyo dentao",
  "block.minecraft.banner.diagonal_left.black": "Tahao êccuro",
  "block.minecraft.banner.diagonal_left.blue": "Tahao açûh",
  "block.minecraft.banner.diagonal_left.brown": "Tahao marrón",
  "block.minecraft.banner.diagonal_left.cyan": "Tahao çian",
  "block.minecraft.banner.diagonal_left.gray": "Tahao grîh",
  "block.minecraft.banner.diagonal_left.green": "Tahao berde",
  "block.minecraft.banner.diagonal_left.light_blue": "Tahao açûh claro",
  "block.minecraft.banner.diagonal_left.light_gray": "Tahao grîh claro",
  "block.minecraft.banner.diagonal_left.lime": "Tahao lima",
  "block.minecraft.banner.diagonal_left.magenta": "Tahao mahenta",
  "block.minecraft.banner.diagonal_left.orange": "Tahao naranha",
  "block.minecraft.banner.diagonal_left.pink": "Tahao roça",
  "block.minecraft.banner.diagonal_left.purple": "Tahao morao",
  "block.minecraft.banner.diagonal_left.red": "Tahao colorao",
  "block.minecraft.banner.diagonal_left.white": "Tahao blanco",
  "block.minecraft.banner.diagonal_left.yellow": "Tahao amariyo",
  "block.minecraft.banner.diagonal_right.black": "Tronxao êccuro",
  "block.minecraft.banner.diagonal_right.blue": "Tronxao açûh",
  "block.minecraft.banner.diagonal_right.brown": "Tronxao marrón",
  "block.minecraft.banner.diagonal_right.cyan": "Tronxao çian",
  "block.minecraft.banner.diagonal_right.gray": "Tronxao grîh",
  "block.minecraft.banner.diagonal_right.green": "Tronxao berde",
  "block.minecraft.banner.diagonal_right.light_blue": "Tronxao açûh claro",
  "block.minecraft.banner.diagonal_right.light_gray": "Tronxao grîh claro",
  "block.minecraft.banner.diagonal_right.lime": "Tronxao lima",
  "block.minecraft.banner.diagonal_right.magenta": "Tronxao mahenta",
  "block.minecraft.banner.diagonal_right.orange": "Tronxao naranha",
  "block.minecraft.banner.diagonal_right.pink": "Tronxao roça",
  "block.minecraft.banner.diagonal_right.purple": "Tronxao morao",
  "block.minecraft.banner.diagonal_right.red": "Tronxao colorao",
  "block.minecraft.banner.diagonal_right.white": "Tronxao blanco",
  "block.minecraft.banner.diagonal_right.yellow": "Tronxao amariyo",
  "block.minecraft.banner.diagonal_up_left.black": "Tronxao êccuro imbertío",
  "block.minecraft.banner.diagonal_up_left.blue": "Tronxao açûh imbertío",
  "block.minecraft.banner.diagonal_up_left.brown": "Tronxao marrón imbertío",
  "block.minecraft.banner.diagonal_up_left.cyan": "Tronxao çian imbertío",
  "block.minecraft.banner.diagonal_up_left.gray": "Tronxao grîh imbertío",
  "block.minecraft.banner.diagonal_up_left.green": "Tronxao berde imbertío",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Tronxao açûh claro imbertío",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Tronxao grîh claro imbertío",
  "block.minecraft.banner.diagonal_up_left.lime": "Tronxao lima imbertío",
  "block.minecraft.banner.diagonal_up_left.magenta": "Tronxao mahenta imbertío",
  "block.minecraft.banner.diagonal_up_left.orange": "Tronxao naranha imbertío",
  "block.minecraft.banner.diagonal_up_left.pink": "Tronxao roça imbertío",
  "block.minecraft.banner.diagonal_up_left.purple": "Tronxao morao imbertío",
  "block.minecraft.banner.diagonal_up_left.red": "Tronxao colorao imbertío",
  "block.minecraft.banner.diagonal_up_left.white": "Tronxao blanco imbertío",
  "block.minecraft.banner.diagonal_up_left.yellow": "Tronxao amariyo imbertío",
  "block.minecraft.banner.diagonal_up_right.black": "Tahao êccuro imbertío",
  "block.minecraft.banner.diagonal_up_right.blue": "Tahao açûh imbertío",
  "block.minecraft.banner.diagonal_up_right.brown": "Tahao marrón imbertío",
  "block.minecraft.banner.diagonal_up_right.cyan": "Tahao çian imbertío",
  "block.minecraft.banner.diagonal_up_right.gray": "Tahao grîh imbertío",
  "block.minecraft.banner.diagonal_up_right.green": "Tahao berde imbertío",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Tahao açûh claro imbertío",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Tahao grîh claro imbertío",
  "block.minecraft.banner.diagonal_up_right.lime": "Tahao lima imbertío",
  "block.minecraft.banner.diagonal_up_right.magenta": "Tahao mahenta imbertío",
  "block.minecraft.banner.diagonal_up_right.orange": "Tahao naranha imbertío",
  "block.minecraft.banner.diagonal_up_right.pink": "Tahao roça imbertío",
  "block.minecraft.banner.diagonal_up_right.purple": "Tahao morao imbertío",
  "block.minecraft.banner.diagonal_up_right.red": "Tahao colorao imbertío",
  "block.minecraft.banner.diagonal_up_right.white": "Tahao blanco imbertío",
  "block.minecraft.banner.diagonal_up_right.yellow": "Tahao amariyo imbertío",
  "block.minecraft.banner.flow.black": "Êttampao êccuro d'êppirâh",
  "block.minecraft.banner.flow.blue": "Êttampao açûh d'êppirâh",
  "block.minecraft.banner.flow.brown": "Êttampao marrón d'êppirâh",
  "block.minecraft.banner.flow.cyan": "Êttampao çian d'êppirâh",
  "block.minecraft.banner.flow.gray": "Êttampao grîh d'êppirâh",
  "block.minecraft.banner.flow.green": "Êttampao berde d'êppirâh",
  "block.minecraft.banner.flow.light_blue": "Êttampao açûh claro d'êppirâh",
  "block.minecraft.banner.flow.light_gray": "Êttampao grîh claro d'êppirâh",
  "block.minecraft.banner.flow.lime": "Êttampao berde lima d'êppirâh",
  "block.minecraft.banner.flow.magenta": "Êttampao mahenta d'êppirâh",
  "block.minecraft.banner.flow.orange": "Êttampao naranha d'êppirâh",
  "block.minecraft.banner.flow.pink": "Êttampao roça d'êppirâh",
  "block.minecraft.banner.flow.purple": "Êttampao morao d'êppirâh",
  "block.minecraft.banner.flow.red": "Êttampao roho d'êppirâh",
  "block.minecraft.banner.flow.white": "Êttampao blanco d'êppirâh",
  "block.minecraft.banner.flow.yellow": "Êttampao amariyo d'êppirâh",
  "block.minecraft.banner.flower.black": "Êttampao êccuro de flôh",
  "block.minecraft.banner.flower.blue": "Êttampao açûh de flôh",
  "block.minecraft.banner.flower.brown": "Êttampao marrón de flôh",
  "block.minecraft.banner.flower.cyan": "Êttampao çian de flôh",
  "block.minecraft.banner.flower.gray": "Êttampao grîh de flôh",
  "block.minecraft.banner.flower.green": "Êttampao berde de flôh",
  "block.minecraft.banner.flower.light_blue": "Êttampao açûh claro de flôh",
  "block.minecraft.banner.flower.light_gray": "Êttampao grîh claro de flôh",
  "block.minecraft.banner.flower.lime": "Êttampao lima de flôh",
  "block.minecraft.banner.flower.magenta": "Êttampao mahenta de flôh",
  "block.minecraft.banner.flower.orange": "Êttampao naranha de flôh",
  "block.minecraft.banner.flower.pink": "Êttampao roça de flôh",
  "block.minecraft.banner.flower.purple": "Êttampao morao de flôh",
  "block.minecraft.banner.flower.red": "Êttampao colorao de flôh",
  "block.minecraft.banner.flower.white": "Êttampao blanco de flôh",
  "block.minecraft.banner.flower.yellow": "Êttampao amariyo de flôh",
  "block.minecraft.banner.globe.black": "Planeta êccuro",
  "block.minecraft.banner.globe.blue": "Planeta açûh",
  "block.minecraft.banner.globe.brown": "Planeta marrón",
  "block.minecraft.banner.globe.cyan": "Planeta çian",
  "block.minecraft.banner.globe.gray": "Planeta grîh",
  "block.minecraft.banner.globe.green": "Planeta berde",
  "block.minecraft.banner.globe.light_blue": "Planeta açûh claro",
  "block.minecraft.banner.globe.light_gray": "Planeta grîh claro",
  "block.minecraft.banner.globe.lime": "Planeta lima",
  "block.minecraft.banner.globe.magenta": "Planeta mahenta",
  "block.minecraft.banner.globe.orange": "Planeta naranha",
  "block.minecraft.banner.globe.pink": "Planeta roça",
  "block.minecraft.banner.globe.purple": "Planeta morao",
  "block.minecraft.banner.globe.red": "Planeta colorao",
  "block.minecraft.banner.globe.white": "Planeta blanco",
  "block.minecraft.banner.globe.yellow": "Planeta amariyo",
  "block.minecraft.banner.gradient.black": "Degradao êccuro",
  "block.minecraft.banner.gradient.blue": "Degradao açûh",
  "block.minecraft.banner.gradient.brown": "Degradao marrón",
  "block.minecraft.banner.gradient.cyan": "Degradao çian",
  "block.minecraft.banner.gradient.gray": "Degradao grîh",
  "block.minecraft.banner.gradient.green": "Degradao berde",
  "block.minecraft.banner.gradient.light_blue": "Degradao açûh claro",
  "block.minecraft.banner.gradient.light_gray": "Degradao grîh claro",
  "block.minecraft.banner.gradient.lime": "Degradao lima",
  "block.minecraft.banner.gradient.magenta": "Degradao mahenta",
  "block.minecraft.banner.gradient.orange": "Degradao naranha",
  "block.minecraft.banner.gradient.pink": "Degradao roça",
  "block.minecraft.banner.gradient.purple": "Degradao morao",
  "block.minecraft.banner.gradient.red": "Degradao colorao",
  "block.minecraft.banner.gradient.white": "Degradao blanco",
  "block.minecraft.banner.gradient.yellow": "Degradao amariyo",
  "block.minecraft.banner.gradient_up.black": "Degradao êccuro en baçe",
  "block.minecraft.banner.gradient_up.blue": "Degradao açûh en baçe",
  "block.minecraft.banner.gradient_up.brown": "Degradao marrón en baçe",
  "block.minecraft.banner.gradient_up.cyan": "Degradao çian en baçe",
  "block.minecraft.banner.gradient_up.gray": "Degradao grîh en baçe",
  "block.minecraft.banner.gradient_up.green": "Degradao berde en baçe",
  "block.minecraft.banner.gradient_up.light_blue": "Degradao açûh claro en baçe",
  "block.minecraft.banner.gradient_up.light_gray": "Degradao grîh claro en baçe",
  "block.minecraft.banner.gradient_up.lime": "Degradao lima en baçe",
  "block.minecraft.banner.gradient_up.magenta": "Degradao mahenta en baçe",
  "block.minecraft.banner.gradient_up.orange": "Degradao naranha en baçe",
  "block.minecraft.banner.gradient_up.pink": "Degradao roça en baçe",
  "block.minecraft.banner.gradient_up.purple": "Degradao morao en baçe",
  "block.minecraft.banner.gradient_up.red": "Degradao colorao en baçe",
  "block.minecraft.banner.gradient_up.white": "Degradao blanco en baçe",
  "block.minecraft.banner.gradient_up.yellow": "Degradao amariyo en baçe",
  "block.minecraft.banner.guster.black": "Êttampao êccuro de breeze",
  "block.minecraft.banner.guster.blue": "Êttampao açûh de breeze",
  "block.minecraft.banner.guster.brown": "Êttampao marrón de breeze",
  "block.minecraft.banner.guster.cyan": "Êttampao çian de breeze",
  "block.minecraft.banner.guster.gray": "Êttampao grîh de breeze",
  "block.minecraft.banner.guster.green": "Êttampao berde de breeze",
  "block.minecraft.banner.guster.light_blue": "Êttampao açûh claro de breeze",
  "block.minecraft.banner.guster.light_gray": "Êttampao grîh claro de breeze",
  "block.minecraft.banner.guster.lime": "Êttampao berde lima de breeze",
  "block.minecraft.banner.guster.magenta": "Êttampao mahenta de breeze",
  "block.minecraft.banner.guster.orange": "Êttampao naranha de breeze",
  "block.minecraft.banner.guster.pink": "Êttampao roça de breeze",
  "block.minecraft.banner.guster.purple": "Êttampao morao de breeze",
  "block.minecraft.banner.guster.red": "Êttampao colorao de breeze",
  "block.minecraft.banner.guster.white": "Êttampao blanco de breeze",
  "block.minecraft.banner.guster.yellow": "Êttampao amariyo de breeze",
  "block.minecraft.banner.half_horizontal.black": "Cortao êccuro",
  "block.minecraft.banner.half_horizontal.blue": "Cortao açûh",
  "block.minecraft.banner.half_horizontal.brown": "Cortao marrón",
  "block.minecraft.banner.half_horizontal.cyan": "Cortao çian",
  "block.minecraft.banner.half_horizontal.gray": "Cortao grîh",
  "block.minecraft.banner.half_horizontal.green": "Cortao berde",
  "block.minecraft.banner.half_horizontal.light_blue": "Cortao açûh claro",
  "block.minecraft.banner.half_horizontal.light_gray": "Cortao grîh claro",
  "block.minecraft.banner.half_horizontal.lime": "Cortao lima",
  "block.minecraft.banner.half_horizontal.magenta": "Cortao mahenta",
  "block.minecraft.banner.half_horizontal.orange": "Cortao naranha",
  "block.minecraft.banner.half_horizontal.pink": "Cortao roça",
  "block.minecraft.banner.half_horizontal.purple": "Cortao morao",
  "block.minecraft.banner.half_horizontal.red": "Cortao colorao",
  "block.minecraft.banner.half_horizontal.white": "Cortao blanco",
  "block.minecraft.banner.half_horizontal.yellow": "Cortao amariyo",
  "block.minecraft.banner.half_horizontal_bottom.black": "Cortao êccuro imbertío",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Cortao açûh imbertío",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Cortao marrón imbertío",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Cortao çian imbertío",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Cortao grîh imbertío",
  "block.minecraft.banner.half_horizontal_bottom.green": "Cortao berde imbertío",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Cortao açûh claro imbertío",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Cortao grîh claro imbertío",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Cortao lima imbertío",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Cortao mahenta imbertío",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Cortao naranha imbertío",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Cortao roça imbertío",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Cortao morao imbertío",
  "block.minecraft.banner.half_horizontal_bottom.red": "Cortao colorao imbertío",
  "block.minecraft.banner.half_horizontal_bottom.white": "Cortao blanco imbertío",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Cortao amariyo imbertío",
  "block.minecraft.banner.half_vertical.black": "Flanco êccuro",
  "block.minecraft.banner.half_vertical.blue": "Flanco açûh",
  "block.minecraft.banner.half_vertical.brown": "Flanco marrón",
  "block.minecraft.banner.half_vertical.cyan": "Flanco çian",
  "block.minecraft.banner.half_vertical.gray": "Flanco grîh",
  "block.minecraft.banner.half_vertical.green": "Flanco berde",
  "block.minecraft.banner.half_vertical.light_blue": "Flanco açûh claro",
  "block.minecraft.banner.half_vertical.light_gray": "Flanco grîh claro",
  "block.minecraft.banner.half_vertical.lime": "Flanco lima",
  "block.minecraft.banner.half_vertical.magenta": "Flanco mahenta",
  "block.minecraft.banner.half_vertical.orange": "Flanco naranha",
  "block.minecraft.banner.half_vertical.pink": "Flanco roça",
  "block.minecraft.banner.half_vertical.purple": "Flanco morao",
  "block.minecraft.banner.half_vertical.red": "Flanco colorao",
  "block.minecraft.banner.half_vertical.white": "Flanco blanco",
  "block.minecraft.banner.half_vertical.yellow": "Flanco amariyo",
  "block.minecraft.banner.half_vertical_right.black": "Flanco êccuro imbertío",
  "block.minecraft.banner.half_vertical_right.blue": "Flanco açûh imbertío",
  "block.minecraft.banner.half_vertical_right.brown": "Flanco marrón imbertío",
  "block.minecraft.banner.half_vertical_right.cyan": "Flanco çian imbertío",
  "block.minecraft.banner.half_vertical_right.gray": "Flanco grîh imbertío",
  "block.minecraft.banner.half_vertical_right.green": "Flanco berde imbertío",
  "block.minecraft.banner.half_vertical_right.light_blue": "Flanco açûh claro imbertío",
  "block.minecraft.banner.half_vertical_right.light_gray": "Flanco grîh claro imbertío",
  "block.minecraft.banner.half_vertical_right.lime": "Flanco lima imbertío",
  "block.minecraft.banner.half_vertical_right.magenta": "Flanco mahenta imbertío",
  "block.minecraft.banner.half_vertical_right.orange": "Flanco naranha imbertío",
  "block.minecraft.banner.half_vertical_right.pink": "Flanco roça imbertío",
  "block.minecraft.banner.half_vertical_right.purple": "Flanco morao imbertío",
  "block.minecraft.banner.half_vertical_right.red": "Flanco colorao imbertío",
  "block.minecraft.banner.half_vertical_right.white": "Flanco blanco imbertío",
  "block.minecraft.banner.half_vertical_right.yellow": "Flanco amariyo imbertío",
  "block.minecraft.banner.mojang.black": "Êttampao êccuro de Mojang",
  "block.minecraft.banner.mojang.blue": "Êttampao açûh de Mojang",
  "block.minecraft.banner.mojang.brown": "Êttampao marrón de Mojang",
  "block.minecraft.banner.mojang.cyan": "Êttampao çian de Mojang",
  "block.minecraft.banner.mojang.gray": "Êttampao grîh de Mojang",
  "block.minecraft.banner.mojang.green": "Êttampao berde de Mojang",
  "block.minecraft.banner.mojang.light_blue": "Êttampao açûh claro de Mojang",
  "block.minecraft.banner.mojang.light_gray": "Êttampao grîh claro de Mojang",
  "block.minecraft.banner.mojang.lime": "Êttampao lima de Mojang",
  "block.minecraft.banner.mojang.magenta": "Êttampao mahenta de Mojang",
  "block.minecraft.banner.mojang.orange": "Êttampao naranha de Mojang",
  "block.minecraft.banner.mojang.pink": "Êttampao roça de Mojang",
  "block.minecraft.banner.mojang.purple": "Êttampao morao de Mojang",
  "block.minecraft.banner.mojang.red": "Êttampao colorao de Mojang",
  "block.minecraft.banner.mojang.white": "Êttampao blanco de Mojang",
  "block.minecraft.banner.mojang.yellow": "Êttampao amariyo de Mojang",
  "block.minecraft.banner.piglin.black": "Hoçico êccuro",
  "block.minecraft.banner.piglin.blue": "Hoçico açûh",
  "block.minecraft.banner.piglin.brown": "Hoçico marrón",
  "block.minecraft.banner.piglin.cyan": "Hoçico çian",
  "block.minecraft.banner.piglin.gray": "Hoçico grîh",
  "block.minecraft.banner.piglin.green": "Hoçico berde",
  "block.minecraft.banner.piglin.light_blue": "Hoçico açûh claro",
  "block.minecraft.banner.piglin.light_gray": "Hoçico grîh claro",
  "block.minecraft.banner.piglin.lime": "Hoçico lima",
  "block.minecraft.banner.piglin.magenta": "Hoçico mahenta",
  "block.minecraft.banner.piglin.orange": "Hoçico naranha",
  "block.minecraft.banner.piglin.pink": "Hoçico roça",
  "block.minecraft.banner.piglin.purple": "Hoçico morao",
  "block.minecraft.banner.piglin.red": "Hoçico coloráo",
  "block.minecraft.banner.piglin.white": "Hoçico blanco",
  "block.minecraft.banner.piglin.yellow": "Hoçico amariyo",
  "block.minecraft.banner.rhombus.black": "Rombo êccuro",
  "block.minecraft.banner.rhombus.blue": "Rombo açûh",
  "block.minecraft.banner.rhombus.brown": "Rombo marrón",
  "block.minecraft.banner.rhombus.cyan": "Rombo çian",
  "block.minecraft.banner.rhombus.gray": "Rombo grîh",
  "block.minecraft.banner.rhombus.green": "Rombo berde",
  "block.minecraft.banner.rhombus.light_blue": "Rombo açûh claro",
  "block.minecraft.banner.rhombus.light_gray": "Rombo grîh claro",
  "block.minecraft.banner.rhombus.lime": "Rombo lima",
  "block.minecraft.banner.rhombus.magenta": "Rombo mahenta",
  "block.minecraft.banner.rhombus.orange": "Rombo naranha",
  "block.minecraft.banner.rhombus.pink": "Rombo roça",
  "block.minecraft.banner.rhombus.purple": "Rombo morao",
  "block.minecraft.banner.rhombus.red": "Rombo colorao",
  "block.minecraft.banner.rhombus.white": "Rombo blanco",
  "block.minecraft.banner.rhombus.yellow": "Rombo amariyo",
  "block.minecraft.banner.skull.black": "Êttampao êccuro de calabera",
  "block.minecraft.banner.skull.blue": "Êttampao açûh de calabera",
  "block.minecraft.banner.skull.brown": "Êttampao marrón de calabera",
  "block.minecraft.banner.skull.cyan": "Êttampao çian de calabera",
  "block.minecraft.banner.skull.gray": "Êttampao grîh de calabera",
  "block.minecraft.banner.skull.green": "Êttampao berde de calabera",
  "block.minecraft.banner.skull.light_blue": "Êttampao açûh claro de calabera",
  "block.minecraft.banner.skull.light_gray": "Êttampao grîh claro de calabera",
  "block.minecraft.banner.skull.lime": "Êttampao lima de calabera",
  "block.minecraft.banner.skull.magenta": "Êttampao mahenta de calabera",
  "block.minecraft.banner.skull.orange": "Êttampao naranha de calabera",
  "block.minecraft.banner.skull.pink": "Êttampao roça de calabera",
  "block.minecraft.banner.skull.purple": "Êttampao morao de calabera",
  "block.minecraft.banner.skull.red": "Êttampao colorao de calabera",
  "block.minecraft.banner.skull.white": "Êttampao blanco de calabera",
  "block.minecraft.banner.skull.yellow": "Êttampao amariyo de calabera",
  "block.minecraft.banner.small_stripes.black": "Bâttonao êccuro",
  "block.minecraft.banner.small_stripes.blue": "Bâttonao açûh",
  "block.minecraft.banner.small_stripes.brown": "Bâttonao marrón",
  "block.minecraft.banner.small_stripes.cyan": "Bâttonao çian",
  "block.minecraft.banner.small_stripes.gray": "Bâttonao grîh",
  "block.minecraft.banner.small_stripes.green": "Bâttonao berde",
  "block.minecraft.banner.small_stripes.light_blue": "Bâttonao açûh claro",
  "block.minecraft.banner.small_stripes.light_gray": "Bâttonao grîh claro",
  "block.minecraft.banner.small_stripes.lime": "Bâttonao lima",
  "block.minecraft.banner.small_stripes.magenta": "Bâttonao mahenta",
  "block.minecraft.banner.small_stripes.orange": "Bâttonao naranha",
  "block.minecraft.banner.small_stripes.pink": "Bâttonao roça",
  "block.minecraft.banner.small_stripes.purple": "Bâttonao morao",
  "block.minecraft.banner.small_stripes.red": "Bâttonao colorao",
  "block.minecraft.banner.small_stripes.white": "Bâttonao blanco",
  "block.minecraft.banner.small_stripes.yellow": "Bâttonao amariyo",
  "block.minecraft.banner.square_bottom_left.black": "Cantón êccuro en campaña a diêttra",
  "block.minecraft.banner.square_bottom_left.blue": "Cantón açûh en campaña a diêttra",
  "block.minecraft.banner.square_bottom_left.brown": "Cantón marrón en campaña a diêttra",
  "block.minecraft.banner.square_bottom_left.cyan": "Cantón çian en campaña a diêttra",
  "block.minecraft.banner.square_bottom_left.gray": "Cantón grîh en campaña a diêttra",
  "block.minecraft.banner.square_bottom_left.green": "Cantón berde en campaña a diêttra",
  "block.minecraft.banner.square_bottom_left.light_blue": "Cantón açûh claro en campaña a diêttra",
  "block.minecraft.banner.square_bottom_left.light_gray": "Cantón grîh claro en campaña a diêttra",
  "block.minecraft.banner.square_bottom_left.lime": "Cantón lima en campaña a diêttra",
  "block.minecraft.banner.square_bottom_left.magenta": "Cantón açûh claro en campaña a diêttra",
  "block.minecraft.banner.square_bottom_left.orange": "Cantón naranha en campaña a diêttra",
  "block.minecraft.banner.square_bottom_left.pink": "Cantón roça en campaña a diêttra",
  "block.minecraft.banner.square_bottom_left.purple": "Cantón morao en campaña a diêttra",
  "block.minecraft.banner.square_bottom_left.red": "Cantón colorao en campaña a diêttra",
  "block.minecraft.banner.square_bottom_left.white": "Cantón blanco en campaña a diêttra",
  "block.minecraft.banner.square_bottom_left.yellow": "Cantón amariyo en campaña a diêttra",
  "block.minecraft.banner.square_bottom_right.black": "Cantón êccuro en campaña a çiniêttra",
  "block.minecraft.banner.square_bottom_right.blue": "Cantón açûh en campaña a çiniêttra",
  "block.minecraft.banner.square_bottom_right.brown": "Cantón marrón en campaña a çiniêttra",
  "block.minecraft.banner.square_bottom_right.cyan": "Cantón çian en campaña a çiniêttra",
  "block.minecraft.banner.square_bottom_right.gray": "Cantón grîh en campaña a çiniêttra",
  "block.minecraft.banner.square_bottom_right.green": "Cantón berde en campaña a çiniêttra",
  "block.minecraft.banner.square_bottom_right.light_blue": "Cantón açûh claro en campaña a çiniêttra",
  "block.minecraft.banner.square_bottom_right.light_gray": "Cantón grîh claro en campaña a çiniêttra",
  "block.minecraft.banner.square_bottom_right.lime": "Cantón lima en campaña a çiniêttra",
  "block.minecraft.banner.square_bottom_right.magenta": "Cantón mahenta en campaña a çiniêttra",
  "block.minecraft.banner.square_bottom_right.orange": "Cantón naranha en campaña a çiniêttra",
  "block.minecraft.banner.square_bottom_right.pink": "Cantón roça en campaña a çiniêttra",
  "block.minecraft.banner.square_bottom_right.purple": "Cantón morao en campaña a çiniêttra",
  "block.minecraft.banner.square_bottom_right.red": "Cantón colorao en campaña a çiniêttra",
  "block.minecraft.banner.square_bottom_right.white": "Cantón blanco en campaña a çiniêttra",
  "block.minecraft.banner.square_bottom_right.yellow": "Cantón amariyo en campaña a çiniêttra",
  "block.minecraft.banner.square_top_left.black": "Cantón êccuro en hefe a diêttra",
  "block.minecraft.banner.square_top_left.blue": "Cantón açûh en hefe a diêttra",
  "block.minecraft.banner.square_top_left.brown": "Cantón marrón en hefe a diêttra",
  "block.minecraft.banner.square_top_left.cyan": "Cantón çian en hefe a diêttra",
  "block.minecraft.banner.square_top_left.gray": "Cantón grîh en hefe a diêttra",
  "block.minecraft.banner.square_top_left.green": "Cantón berde en hefe a diêttra",
  "block.minecraft.banner.square_top_left.light_blue": "Cantón açûh claro en hefe a diêttra",
  "block.minecraft.banner.square_top_left.light_gray": "Cantón grîh claro en hefe a diêttra",
  "block.minecraft.banner.square_top_left.lime": "Cantón lima en hefe a diêttra",
  "block.minecraft.banner.square_top_left.magenta": "Cantón mahenta en hefe a diêttra",
  "block.minecraft.banner.square_top_left.orange": "Cantón naranha en hefe a diêttra",
  "block.minecraft.banner.square_top_left.pink": "Cantón roça en hefe a diêttra",
  "block.minecraft.banner.square_top_left.purple": "Cantón morao en hefe a diêttra",
  "block.minecraft.banner.square_top_left.red": "Cantón colorao en hefe a diêttra",
  "block.minecraft.banner.square_top_left.white": "Cantón blanco en hefe a diêttra",
  "block.minecraft.banner.square_top_left.yellow": "Cantón amariyo en hefe a diêttra",
  "block.minecraft.banner.square_top_right.black": "Cantón êccuro en hefe a çiniêttra",
  "block.minecraft.banner.square_top_right.blue": "Cantón açûh en hefe a çiniêttra",
  "block.minecraft.banner.square_top_right.brown": "Cantón marrón en hefe a çiniêttra",
  "block.minecraft.banner.square_top_right.cyan": "Cantón çian en hefe a çiniêttra",
  "block.minecraft.banner.square_top_right.gray": "Cantón grîh en hefe a çiniêttra",
  "block.minecraft.banner.square_top_right.green": "Cantón berde en hefe a çiniêttra",
  "block.minecraft.banner.square_top_right.light_blue": "Cantón açûh claro en hefe a çiniêttra",
  "block.minecraft.banner.square_top_right.light_gray": "Cantón grîh claro en hefe a çiniêttra",
  "block.minecraft.banner.square_top_right.lime": "Cantón lima en hefe a çiniêttra",
  "block.minecraft.banner.square_top_right.magenta": "Cantón mahenta en hefe a çiniêttra",
  "block.minecraft.banner.square_top_right.orange": "Cantón naranha en hefe a çiniêttra",
  "block.minecraft.banner.square_top_right.pink": "Cantón roça en hefe a çiniêttra",
  "block.minecraft.banner.square_top_right.purple": "Cantón morao en hefe a çiniêttra",
  "block.minecraft.banner.square_top_right.red": "Cantón colorao en hefe a çiniêttra",
  "block.minecraft.banner.square_top_right.white": "Cantón blanco en hefe a çiniêttra",
  "block.minecraft.banner.square_top_right.yellow": "Cantón amariyo en hefe a çiniêttra",
  "block.minecraft.banner.straight_cross.black": "Crûh êccura",
  "block.minecraft.banner.straight_cross.blue": "Crûh açûh",
  "block.minecraft.banner.straight_cross.brown": "Crûh marrón",
  "block.minecraft.banner.straight_cross.cyan": "Crûh çian",
  "block.minecraft.banner.straight_cross.gray": "Crûh grîh",
  "block.minecraft.banner.straight_cross.green": "Crûh berde",
  "block.minecraft.banner.straight_cross.light_blue": "Crûh açûh claro",
  "block.minecraft.banner.straight_cross.light_gray": "Crûh grîh claro",
  "block.minecraft.banner.straight_cross.lime": "Crûh lima",
  "block.minecraft.banner.straight_cross.magenta": "Crûh mahenta",
  "block.minecraft.banner.straight_cross.orange": "Crûh naranha",
  "block.minecraft.banner.straight_cross.pink": "Crûh roça",
  "block.minecraft.banner.straight_cross.purple": "Crûh morá",
  "block.minecraft.banner.straight_cross.red": "Crûh colorá",
  "block.minecraft.banner.straight_cross.white": "Crûh blanca",
  "block.minecraft.banner.straight_cross.yellow": "Crûh amariya",
  "block.minecraft.banner.stripe_bottom.black": "Campaña êccura",
  "block.minecraft.banner.stripe_bottom.blue": "Campaña açûh",
  "block.minecraft.banner.stripe_bottom.brown": "Campaña marrón",
  "block.minecraft.banner.stripe_bottom.cyan": "Campaña çian",
  "block.minecraft.banner.stripe_bottom.gray": "Campaña grîh",
  "block.minecraft.banner.stripe_bottom.green": "Campaña berde",
  "block.minecraft.banner.stripe_bottom.light_blue": "Campaña açûh claro",
  "block.minecraft.banner.stripe_bottom.light_gray": "Campaña grîh claro",
  "block.minecraft.banner.stripe_bottom.lime": "Campaña lima",
  "block.minecraft.banner.stripe_bottom.magenta": "Campaña mahenta",
  "block.minecraft.banner.stripe_bottom.orange": "Campaña naranha",
  "block.minecraft.banner.stripe_bottom.pink": "Campaña roça",
  "block.minecraft.banner.stripe_bottom.purple": "Campaña morá",
  "block.minecraft.banner.stripe_bottom.red": "Campaña colorá",
  "block.minecraft.banner.stripe_bottom.white": "Campaña blanca",
  "block.minecraft.banner.stripe_bottom.yellow": "Campaña amariya",
  "block.minecraft.banner.stripe_center.black": "Palo êccuro",
  "block.minecraft.banner.stripe_center.blue": "Palo açûh",
  "block.minecraft.banner.stripe_center.brown": "Palo marrón",
  "block.minecraft.banner.stripe_center.cyan": "Palo çian",
  "block.minecraft.banner.stripe_center.gray": "Palo grîh",
  "block.minecraft.banner.stripe_center.green": "Palo berde",
  "block.minecraft.banner.stripe_center.light_blue": "Palo açûh claro",
  "block.minecraft.banner.stripe_center.light_gray": "Palo grîh claro",
  "block.minecraft.banner.stripe_center.lime": "Palo lima",
  "block.minecraft.banner.stripe_center.magenta": "Palo mahenta",
  "block.minecraft.banner.stripe_center.orange": "Palo naranha",
  "block.minecraft.banner.stripe_center.pink": "Palo roça",
  "block.minecraft.banner.stripe_center.purple": "Palo morao",
  "block.minecraft.banner.stripe_center.red": "Palo colorao",
  "block.minecraft.banner.stripe_center.white": "Palo blanco",
  "block.minecraft.banner.stripe_center.yellow": "Palo amariyo",
  "block.minecraft.banner.stripe_downleft.black": "Banda êccura a çiniêttra",
  "block.minecraft.banner.stripe_downleft.blue": "Banda açûh a çiniêttra",
  "block.minecraft.banner.stripe_downleft.brown": "Banda marrón a çiniêttra",
  "block.minecraft.banner.stripe_downleft.cyan": "Banda çian a çiniêttra",
  "block.minecraft.banner.stripe_downleft.gray": "Banda grîh a çiniêttra",
  "block.minecraft.banner.stripe_downleft.green": "Banda berde a çiniêttra",
  "block.minecraft.banner.stripe_downleft.light_blue": "Banda açûh claro a çiniêttra",
  "block.minecraft.banner.stripe_downleft.light_gray": "Banda grîh claro a çiniêttra",
  "block.minecraft.banner.stripe_downleft.lime": "Banda lima a çiniêttra",
  "block.minecraft.banner.stripe_downleft.magenta": "Banda mahenta a çiniêttra",
  "block.minecraft.banner.stripe_downleft.orange": "Banda naranha a çiniêttra",
  "block.minecraft.banner.stripe_downleft.pink": "Banda roça a çiniêttra",
  "block.minecraft.banner.stripe_downleft.purple": "Banda morá a çiniêttra",
  "block.minecraft.banner.stripe_downleft.red": "Banda colorá a çiniêttra",
  "block.minecraft.banner.stripe_downleft.white": "Banda blanca a çiniêttra",
  "block.minecraft.banner.stripe_downleft.yellow": "Banda amariya a çiniêttra",
  "block.minecraft.banner.stripe_downright.black": "Banda êccura",
  "block.minecraft.banner.stripe_downright.blue": "Banda açûh",
  "block.minecraft.banner.stripe_downright.brown": "Banda marrón",
  "block.minecraft.banner.stripe_downright.cyan": "Banda çian",
  "block.minecraft.banner.stripe_downright.gray": "Banda grîh",
  "block.minecraft.banner.stripe_downright.green": "Banda berde",
  "block.minecraft.banner.stripe_downright.light_blue": "Banda açûh claro",
  "block.minecraft.banner.stripe_downright.light_gray": "Banda grîh claro",
  "block.minecraft.banner.stripe_downright.lime": "Banda lima",
  "block.minecraft.banner.stripe_downright.magenta": "Banda mahenta",
  "block.minecraft.banner.stripe_downright.orange": "Banda naranha",
  "block.minecraft.banner.stripe_downright.pink": "Banda roça",
  "block.minecraft.banner.stripe_downright.purple": "Banda morá",
  "block.minecraft.banner.stripe_downright.red": "Banda colorá",
  "block.minecraft.banner.stripe_downright.white": "Banda blanca",
  "block.minecraft.banner.stripe_downright.yellow": "Banda amariya",
  "block.minecraft.banner.stripe_left.black": "Palo êccuro a diêttra",
  "block.minecraft.banner.stripe_left.blue": "Palo açûh a diêttra",
  "block.minecraft.banner.stripe_left.brown": "Palo marrón a diêttra",
  "block.minecraft.banner.stripe_left.cyan": "Palo çian a diêttra",
  "block.minecraft.banner.stripe_left.gray": "Palo grîh a diêttra",
  "block.minecraft.banner.stripe_left.green": "Palo berde a diêttra",
  "block.minecraft.banner.stripe_left.light_blue": "Palo açûh claro a diêttra",
  "block.minecraft.banner.stripe_left.light_gray": "Palo grîh claro a diêttra",
  "block.minecraft.banner.stripe_left.lime": "Palo lima a diêttra",
  "block.minecraft.banner.stripe_left.magenta": "Palo mahenta a diêttra",
  "block.minecraft.banner.stripe_left.orange": "Palo naranha a diêttra",
  "block.minecraft.banner.stripe_left.pink": "Palo roça a diêttra",
  "block.minecraft.banner.stripe_left.purple": "Palo morao a diêttra",
  "block.minecraft.banner.stripe_left.red": "Palo colorao a diêttra",
  "block.minecraft.banner.stripe_left.white": "Palo blanco a diêttra",
  "block.minecraft.banner.stripe_left.yellow": "Palo amariyo a diêttra",
  "block.minecraft.banner.stripe_middle.black": "Franha êccura",
  "block.minecraft.banner.stripe_middle.blue": "Franha açûh",
  "block.minecraft.banner.stripe_middle.brown": "Franha marrón",
  "block.minecraft.banner.stripe_middle.cyan": "Franha çian",
  "block.minecraft.banner.stripe_middle.gray": "Franha grîh",
  "block.minecraft.banner.stripe_middle.green": "Franha berde",
  "block.minecraft.banner.stripe_middle.light_blue": "Franha açûh claro",
  "block.minecraft.banner.stripe_middle.light_gray": "Franha grîh claro",
  "block.minecraft.banner.stripe_middle.lime": "Franha lima",
  "block.minecraft.banner.stripe_middle.magenta": "Franha mahenta",
  "block.minecraft.banner.stripe_middle.orange": "Franha naranha",
  "block.minecraft.banner.stripe_middle.pink": "Franha roça",
  "block.minecraft.banner.stripe_middle.purple": "Franha morá",
  "block.minecraft.banner.stripe_middle.red": "Franha colorá",
  "block.minecraft.banner.stripe_middle.white": "Franha blanca",
  "block.minecraft.banner.stripe_middle.yellow": "Franha amariya",
  "block.minecraft.banner.stripe_right.black": "Palo êccuro a çiniêttra",
  "block.minecraft.banner.stripe_right.blue": "Palo açûh a çiniêttra",
  "block.minecraft.banner.stripe_right.brown": "Palo marrón a çiniêttra",
  "block.minecraft.banner.stripe_right.cyan": "Palo çian a çiniêttra",
  "block.minecraft.banner.stripe_right.gray": "Palo grîh a çiniêttra",
  "block.minecraft.banner.stripe_right.green": "Palo berde a çiniêttra",
  "block.minecraft.banner.stripe_right.light_blue": "Palo açûh claro a çiniêttra",
  "block.minecraft.banner.stripe_right.light_gray": "Palo grîh claro a çiniêttra",
  "block.minecraft.banner.stripe_right.lime": "Palo lima a çiniêttra",
  "block.minecraft.banner.stripe_right.magenta": "Palo mahenta a çiniêttra",
  "block.minecraft.banner.stripe_right.orange": "Palo naranha a çiniêttra",
  "block.minecraft.banner.stripe_right.pink": "Palo roça a çiniêttra",
  "block.minecraft.banner.stripe_right.purple": "Palo morao a çiniêttra",
  "block.minecraft.banner.stripe_right.red": "Palo colorao a çiniêttra",
  "block.minecraft.banner.stripe_right.white": "Palo blanco a çiniêttra",
  "block.minecraft.banner.stripe_right.yellow": "Palo amariyo a çiniêttra",
  "block.minecraft.banner.stripe_top.black": "Hefe êccuro",
  "block.minecraft.banner.stripe_top.blue": "Hefe açûh",
  "block.minecraft.banner.stripe_top.brown": "Hefe marrón",
  "block.minecraft.banner.stripe_top.cyan": "Hefe çian",
  "block.minecraft.banner.stripe_top.gray": "Hefe grîh",
  "block.minecraft.banner.stripe_top.green": "Hefe berde",
  "block.minecraft.banner.stripe_top.light_blue": "Hefe açûh claro",
  "block.minecraft.banner.stripe_top.light_gray": "Hefe grîh claro",
  "block.minecraft.banner.stripe_top.lime": "Hefe lima",
  "block.minecraft.banner.stripe_top.magenta": "Hefe mahenta",
  "block.minecraft.banner.stripe_top.orange": "Hefe naranha",
  "block.minecraft.banner.stripe_top.pink": "Hefe roça",
  "block.minecraft.banner.stripe_top.purple": "Hefe morao",
  "block.minecraft.banner.stripe_top.red": "Hefe colorao",
  "block.minecraft.banner.stripe_top.white": "Hefe blanco",
  "block.minecraft.banner.stripe_top.yellow": "Hefe amariyo",
  "block.minecraft.banner.triangle_bottom.black": "Xebrón êccuro",
  "block.minecraft.banner.triangle_bottom.blue": "Xebrón açûh",
  "block.minecraft.banner.triangle_bottom.brown": "Xebrón marrón",
  "block.minecraft.banner.triangle_bottom.cyan": "Xebrón çian",
  "block.minecraft.banner.triangle_bottom.gray": "Xebrón grîh",
  "block.minecraft.banner.triangle_bottom.green": "Xebrón berde",
  "block.minecraft.banner.triangle_bottom.light_blue": "Xebrón açûh claro",
  "block.minecraft.banner.triangle_bottom.light_gray": "Xebrón grîh claro",
  "block.minecraft.banner.triangle_bottom.lime": "Xebrón lima",
  "block.minecraft.banner.triangle_bottom.magenta": "Xebrón mahenta",
  "block.minecraft.banner.triangle_bottom.orange": "Xebrón naranha",
  "block.minecraft.banner.triangle_bottom.pink": "Xebrón roça",
  "block.minecraft.banner.triangle_bottom.purple": "Xebrón morao",
  "block.minecraft.banner.triangle_bottom.red": "Xebrón colorao",
  "block.minecraft.banner.triangle_bottom.white": "Xebrón blanco",
  "block.minecraft.banner.triangle_bottom.yellow": "Xebrón amariyo",
  "block.minecraft.banner.triangle_top.black": "Xebrón êccuro imbertío",
  "block.minecraft.banner.triangle_top.blue": "Xebrón açûh imbertío",
  "block.minecraft.banner.triangle_top.brown": "Xebrón marrón imbertío",
  "block.minecraft.banner.triangle_top.cyan": "Xebrón çian imbertío",
  "block.minecraft.banner.triangle_top.gray": "Xebrón grîh imbertío",
  "block.minecraft.banner.triangle_top.green": "Xebrón berde imbertío",
  "block.minecraft.banner.triangle_top.light_blue": "Xebrón açûh claro imbertío",
  "block.minecraft.banner.triangle_top.light_gray": "Xebrón grîh claro imbertío",
  "block.minecraft.banner.triangle_top.lime": "Xebrón lima imbertío",
  "block.minecraft.banner.triangle_top.magenta": "Xebrón mahenta imbertío",
  "block.minecraft.banner.triangle_top.orange": "Xebrón naranha imbertío",
  "block.minecraft.banner.triangle_top.pink": "Xebrón roça imbertío",
  "block.minecraft.banner.triangle_top.purple": "Xebrón morao imbertío",
  "block.minecraft.banner.triangle_top.red": "Xebrón colorao imbertío",
  "block.minecraft.banner.triangle_top.white": "Xebrón blanco imbertío",
  "block.minecraft.banner.triangle_top.yellow": "Xebrón amariyo imbertío",
  "block.minecraft.banner.triangles_bottom.black": "Baçe êccura dentá",
  "block.minecraft.banner.triangles_bottom.blue": "Baçe açûh dentá",
  "block.minecraft.banner.triangles_bottom.brown": "Baçe marrón dentá",
  "block.minecraft.banner.triangles_bottom.cyan": "Baçe çian dentá",
  "block.minecraft.banner.triangles_bottom.gray": "Baçe grîh dentá",
  "block.minecraft.banner.triangles_bottom.green": "Baçe berde dentá",
  "block.minecraft.banner.triangles_bottom.light_blue": "Baçe açûh claro dentá",
  "block.minecraft.banner.triangles_bottom.light_gray": "Baçe grîh claro dentá",
  "block.minecraft.banner.triangles_bottom.lime": "Baçe lima dentá",
  "block.minecraft.banner.triangles_bottom.magenta": "Baçe morá dentá",
  "block.minecraft.banner.triangles_bottom.orange": "Baçe naranha dentá",
  "block.minecraft.banner.triangles_bottom.pink": "Baçe roça dentá",
  "block.minecraft.banner.triangles_bottom.purple": "Baçe morá dentá",
  "block.minecraft.banner.triangles_bottom.red": "Baçe colorá dentá",
  "block.minecraft.banner.triangles_bottom.white": "Baçe blanca dentá",
  "block.minecraft.banner.triangles_bottom.yellow": "Baçe amariya dentá",
  "block.minecraft.banner.triangles_top.black": "Hefe êccuro dentao",
  "block.minecraft.banner.triangles_top.blue": "Hefe açûh dentao",
  "block.minecraft.banner.triangles_top.brown": "Hefe marrón dentao",
  "block.minecraft.banner.triangles_top.cyan": "Hefe çian dentao",
  "block.minecraft.banner.triangles_top.gray": "Hefe grîh dentao",
  "block.minecraft.banner.triangles_top.green": "Hefe berde dentao",
  "block.minecraft.banner.triangles_top.light_blue": "Hefe açûh claro dentao",
  "block.minecraft.banner.triangles_top.light_gray": "Hefe grîh claro dentao",
  "block.minecraft.banner.triangles_top.lime": "Hefe lima dentao",
  "block.minecraft.banner.triangles_top.magenta": "Hefe mahenta dentao",
  "block.minecraft.banner.triangles_top.orange": "Hefe naranha dentao",
  "block.minecraft.banner.triangles_top.pink": "Hefe roça dentao",
  "block.minecraft.banner.triangles_top.purple": "Hefe morao dentao",
  "block.minecraft.banner.triangles_top.red": "Hefe colorao dentao",
  "block.minecraft.banner.triangles_top.white": "Hefe blanco dentao",
  "block.minecraft.banner.triangles_top.yellow": "Hefe amariyo dentao",
  "block.minecraft.barrel": "Barrîh",
  "block.minecraft.barrier": "Barrera",
  "block.minecraft.basalt": "Baçarto",
  "block.minecraft.beacon": "Faro",
  "block.minecraft.beacon.primary": "Podêh prinçipâh",
  "block.minecraft.beacon.secondary": "Podêh çecundario",
  "block.minecraft.bed.no_sleep": "Na mâh que çe puêh dormîh po'l-la noxe o durante tormentâ elétricâ",
  "block.minecraft.bed.not_safe": "Ara no puêh dormîh; ay môttrô çerca",
  "block.minecraft.bed.obstructed": "La cama ettá ôttruía",
  "block.minecraft.bed.occupied": "La cama êttá ocupá",
  "block.minecraft.bed.too_far_away": "Ara no puêh dormîh; la cama êttá mu lehô",
  "block.minecraft.bedrock": "Roca baçe",
  "block.minecraft.bee_nest": "Cormena",
  "block.minecraft.beehive": "Apiario",
  "block.minecraft.beetroots": "Remolaxâ",
  "block.minecraft.bell": "Campana",
  "block.minecraft.big_dripleaf": "Plantaforma grande",
  "block.minecraft.big_dripleaf_stem": "Tayo de plantaforma grande",
  "block.minecraft.birch_button": "Botón de xopo",
  "block.minecraft.birch_door": "Puerta de xopo",
  "block.minecraft.birch_fence": "Berha de xopo",
  "block.minecraft.birch_fence_gate": "Cançela de xopo",
  "block.minecraft.birch_hanging_sign": "Letrero corgante de xopo",
  "block.minecraft.birch_leaves": "Ohâ de xopo",
  "block.minecraft.birch_log": "Tronco de xopo",
  "block.minecraft.birch_planks": "Tablonê de xopo",
  "block.minecraft.birch_pressure_plate": "Placa de preçión de xopo",
  "block.minecraft.birch_sapling": "Brote de xopo",
  "block.minecraft.birch_shelf": "Êttante de abedûh",
  "block.minecraft.birch_sign": "Letrero de xopo",
  "block.minecraft.birch_slab": "Bardoça de xopo",
  "block.minecraft.birch_stairs": "Êccalerâ de xopo",
  "block.minecraft.birch_trapdoor": "Trampiya de xopo",
  "block.minecraft.birch_wall_hanging_sign": "Letrero corgante de xopo en paré",
  "block.minecraft.birch_wall_sign": "Letrero de xopo en paré",
  "block.minecraft.birch_wood": "Leño de xopo",
  "block.minecraft.black_banner": "Êttandarte êccuro",
  "block.minecraft.black_bed": "Cama êccura",
  "block.minecraft.black_candle": "Çirio êccuro",
  "block.minecraft.black_candle_cake": "Tarta con çirio êccuro",
  "block.minecraft.black_carpet": "Arfombra êccura",
  "block.minecraft.black_concrete": "Hormigón êccuro",
  "block.minecraft.black_concrete_powder": "Çemento êccuro",
  "block.minecraft.black_glazed_terracotta": "Açuleho êccuro",
  "block.minecraft.black_shulker_box": "Caha de shulker êccura",
  "block.minecraft.black_stained_glass": "Crîttâh tintao d'êccuro",
  "block.minecraft.black_stained_glass_pane": "Panêh de crîttâh tintao d'êccuro",
  "block.minecraft.black_terracotta": "Terracota êccura",
  "block.minecraft.black_wool": "Lana êccura",
  "block.minecraft.blackstone": "Açabaxe",
  "block.minecraft.blackstone_slab": "Bardoça d'açabaxe",
  "block.minecraft.blackstone_stairs": "Êccalerâ d'açabaxe",
  "block.minecraft.blackstone_wall": "Muro d'açabaxe",
  "block.minecraft.blast_furnace": "Forha",
  "block.minecraft.blue_banner": "Êttandarte açûh",
  "block.minecraft.blue_bed": "Cama açûh",
  "block.minecraft.blue_candle": "Çirio açûh",
  "block.minecraft.blue_candle_cake": "Tarta con çirio açûh",
  "block.minecraft.blue_carpet": "Arfombra açûh",
  "block.minecraft.blue_concrete": "Hormigón açûh",
  "block.minecraft.blue_concrete_powder": "Çemento açûh",
  "block.minecraft.blue_glazed_terracotta": "Açuleho açûh",
  "block.minecraft.blue_ice": "Yelo açûh",
  "block.minecraft.blue_orchid": "Orquídia açûh",
  "block.minecraft.blue_shulker_box": "Caha de shulker açûh",
  "block.minecraft.blue_stained_glass": "Crîttâh tintao d'açûh",
  "block.minecraft.blue_stained_glass_pane": "Panêh de crîttâh tintao d'açûh",
  "block.minecraft.blue_terracotta": "Terracota açûh",
  "block.minecraft.blue_wool": "Lana açûh",
  "block.minecraft.bone_block": "Bloque de gueço",
  "block.minecraft.bookshelf": "Anaquêh de librô",
  "block.minecraft.brain_coral": "Corâh de çerebro",
  "block.minecraft.brain_coral_block": "Bloque de corâh de çerebro",
  "block.minecraft.brain_coral_fan": "Gorgonia de çerebro",
  "block.minecraft.brain_coral_wall_fan": "Gorgonia de çerebro en paré",
  "block.minecraft.brewing_stand": "Alambique",
  "block.minecraft.brick_slab": "Bardoça de ladriyô",
  "block.minecraft.brick_stairs": "Êccalerâ de ladriyô",
  "block.minecraft.brick_wall": "Muro de ladriyô",
  "block.minecraft.bricks": "Ladriyô",
  "block.minecraft.brown_banner": "Êttandarte marrón",
  "block.minecraft.brown_bed": "Cama marrón",
  "block.minecraft.brown_candle": "Çirio marrón",
  "block.minecraft.brown_candle_cake": "Tarta con çirio marrón",
  "block.minecraft.brown_carpet": "Arfombra marrón",
  "block.minecraft.brown_concrete": "Hormigón marrón",
  "block.minecraft.brown_concrete_powder": "Çemento marrón",
  "block.minecraft.brown_glazed_terracotta": "Açuleho marrón",
  "block.minecraft.brown_mushroom": "Gurumelo marrón",
  "block.minecraft.brown_mushroom_block": "Bloque de gurumelo marrón",
  "block.minecraft.brown_shulker_box": "Caha de shulker marrón",
  "block.minecraft.brown_stained_glass": "Crîttâh tintao de marrón",
  "block.minecraft.brown_stained_glass_pane": "Panêh de crîttâh tintao de marrón",
  "block.minecraft.brown_terracotta": "Terracota marrón",
  "block.minecraft.brown_wool": "Lana marrón",
  "block.minecraft.bubble_column": "Colûnna de burbuhâ",
  "block.minecraft.bubble_coral": "Corâh de burbuhâ",
  "block.minecraft.bubble_coral_block": "Bloque de corâh de burbuha",
  "block.minecraft.bubble_coral_fan": "Gorgonia de burbuha",
  "block.minecraft.bubble_coral_wall_fan": "Gorgonia de burbuha en paré",
  "block.minecraft.budding_amethyst": "Druça d'ametîtta",
  "block.minecraft.bush": "Arbūhto",
  "block.minecraft.cactus": "Câttû",
  "block.minecraft.cactus_flower": "Flor que pinsha",
  "block.minecraft.cake": "Pâttêh",
  "block.minecraft.calcite": "Carçita",
  "block.minecraft.calibrated_sculk_sensor": "Çençôh de sculk calibrao",
  "block.minecraft.campfire": "Candela",
  "block.minecraft.candle": "Çirio",
  "block.minecraft.candle_cake": "Pâttêh con çirio",
  "block.minecraft.carrots": "Çanaoriâ",
  "block.minecraft.cartography_table": "Meça de cartografía",
  "block.minecraft.carved_pumpkin": "Calabaça tayá",
  "block.minecraft.cauldron": "Cardero",
  "block.minecraft.cave_air": "Aire de cueba",
  "block.minecraft.cave_vines": "Enreaera çûtterránea",
  "block.minecraft.cave_vines_plant": "Planta d'enreaera çûtterránea",
  "block.minecraft.chain": "Caena",
  "block.minecraft.chain_command_block": "Bloque de comandô en cadena",
  "block.minecraft.cherry_button": "Botón de çereço",
  "block.minecraft.cherry_door": "Puerta de çereço",
  "block.minecraft.cherry_fence": "Berha de çereço",
  "block.minecraft.cherry_fence_gate": "Cançela de çereço",
  "block.minecraft.cherry_hanging_sign": "Letrero corgante de çereço",
  "block.minecraft.cherry_leaves": "Ohâ de çereço",
  "block.minecraft.cherry_log": "Tronco de çereço",
  "block.minecraft.cherry_planks": "Tablonê de çereço",
  "block.minecraft.cherry_pressure_plate": "Placa de preçión de çereço",
  "block.minecraft.cherry_sapling": "Brote de çereço",
  "block.minecraft.cherry_shelf": "Êttante de çereço",
  "block.minecraft.cherry_sign": "Letrero de çereço",
  "block.minecraft.cherry_slab": "Bardoça de çereço",
  "block.minecraft.cherry_stairs": "Êccalerâ de çereço",
  "block.minecraft.cherry_trapdoor": "Trampiya de çereço",
  "block.minecraft.cherry_wall_hanging_sign": "Letrero corgante de çereço en paré",
  "block.minecraft.cherry_wall_sign": "Letrero de çereço en paré",
  "block.minecraft.cherry_wood": "Leño de çereço",
  "block.minecraft.chest": "Baûh",
  "block.minecraft.chipped_anvil": "Yunque êcconxao",
  "block.minecraft.chiseled_bookshelf": "Anaquêh de librô êccurpío",
  "block.minecraft.chiseled_copper": "Cobre çinçelao",
  "block.minecraft.chiseled_deepslate": "Piçarra êccurpía",
  "block.minecraft.chiseled_nether_bricks": "Ladriyô der Nether êccurpíô",
  "block.minecraft.chiseled_polished_blackstone": "Açabaxe pulío êccurpío",
  "block.minecraft.chiseled_quartz_block": "Cuarço êccurpío",
  "block.minecraft.chiseled_red_sandstone": "Arbero colorao êccurpío",
  "block.minecraft.chiseled_resin_bricks": "Ladriyôh de reçina çinçeláô",
  "block.minecraft.chiseled_sandstone": "Arbero êccurpío",
  "block.minecraft.chiseled_stone_bricks": "Ladriyô de roca êccurpía",
  "block.minecraft.chiseled_tuff": "Toba çinçelá",
  "block.minecraft.chiseled_tuff_bricks": "Ladriyô de toba çinçeláô",
  "block.minecraft.chorus_flower": "Flôh de chorus",
  "block.minecraft.chorus_plant": "Planta de chorus",
  "block.minecraft.clay": "Arçiya",
  "block.minecraft.closed_eyeblossom": "Frô ôho çerráh",
  "block.minecraft.coal_block": "Bloque de carbón",
  "block.minecraft.coal_ore": "Beta de carbón",
  "block.minecraft.coarse_dirt": "Tierra êttérî",
  "block.minecraft.cobbled_deepslate": "Adoquinao de piçarra",
  "block.minecraft.cobbled_deepslate_slab": "Bardoça d'adoquinao de piçarra",
  "block.minecraft.cobbled_deepslate_stairs": "Êccalerâ d'adoquinao de piçarra",
  "block.minecraft.cobbled_deepslate_wall": "Muro d'adoquinao de piçarra",
  "block.minecraft.cobblestone": "Adoquín",
  "block.minecraft.cobblestone_slab": "Bardoça d'adoquín",
  "block.minecraft.cobblestone_stairs": "Êccalerâ d'adoquín",
  "block.minecraft.cobblestone_wall": "Muro d'adoquín",
  "block.minecraft.cobweb": "Telaraña",
  "block.minecraft.cocoa": "Cacao",
  "block.minecraft.command_block": "Bloque de comandô",
  "block.minecraft.comparator": "Comparadôh de redstone",
  "block.minecraft.composter": "Compôttadôh",
  "block.minecraft.conduit": "Canaliçadôh",
  "block.minecraft.copper_bars": "Barrotê de cobre",
  "block.minecraft.copper_block": "Bloque de cobre",
  "block.minecraft.copper_bulb": "Lámpara de cobre",
  "block.minecraft.copper_chain": "Caena de cobre",
  "block.minecraft.copper_chest": "Cofre de cobre",
  "block.minecraft.copper_door": "Puerta de cobre",
  "block.minecraft.copper_golem_statue": "Êttatua de gólem de cobre",
  "block.minecraft.copper_grate": "Rehiya de cobre",
  "block.minecraft.copper_lantern": "Farôh de cobre",
  "block.minecraft.copper_ore": "Beta de cobre",
  "block.minecraft.copper_torch": "Antorxa de cobre",
  "block.minecraft.copper_trapdoor": "Trampiya de cobre",
  "block.minecraft.copper_wall_torch": "Antorxa de cobre de paré",
  "block.minecraft.cornflower": "Açiano",
  "block.minecraft.cracked_deepslate_bricks": "Ladriyô de piçarra rêqquebrahá",
  "block.minecraft.cracked_deepslate_tiles": "Ladriyô de loçetâ de piçarra rêqquebrahá",
  "block.minecraft.cracked_nether_bricks": "Ladriyô der Nether rêqquebrahaô",
  "block.minecraft.cracked_polished_blackstone_bricks": "Ladriyô d'açabaxe pulío rêqquebrahao",
  "block.minecraft.cracked_stone_bricks": "Ladriyô de roca rêqquebrahá",
  "block.minecraft.crafter": "Fabricadôh",
  "block.minecraft.crafting_table": "Meça de crâtteo",
  "block.minecraft.creaking_heart": "Coraçón Cruhiente",
  "block.minecraft.creeper_head": "Cabeça de creeper",
  "block.minecraft.creeper_wall_head": "Cabeça de creeper en paré",
  "block.minecraft.crimson_button": "Botón carmeçí",
  "block.minecraft.crimson_door": "Puerta carmeçí",
  "block.minecraft.crimson_fence": "Berha carmeçí",
  "block.minecraft.crimson_fence_gate": "Cançela carmeçí",
  "block.minecraft.crimson_fungus": "Hongo carmeçí",
  "block.minecraft.crimson_hanging_sign": "Letrero corgante carmeçí",
  "block.minecraft.crimson_hyphae": "Ifâ carmeçîh",
  "block.minecraft.crimson_nylium": "Nilio carmeçí",
  "block.minecraft.crimson_planks": "Tablonê carmeçíê",
  "block.minecraft.crimson_pressure_plate": "Placa de preçión carmeçí",
  "block.minecraft.crimson_roots": "Raíçê carmeçíê",
  "block.minecraft.crimson_shelf": "Êttante carmeçí",
  "block.minecraft.crimson_sign": "Letrero carmeçí",
  "block.minecraft.crimson_slab": "Bardoça carmeçí",
  "block.minecraft.crimson_stairs": "Êccalerâ carmeçíê",
  "block.minecraft.crimson_stem": "Tayo carmeçí",
  "block.minecraft.crimson_trapdoor": "Trampiya carmeçí",
  "block.minecraft.crimson_wall_hanging_sign": "Letrero corgante carmeçí en paré",
  "block.minecraft.crimson_wall_sign": "Letrero carmeçí en paré",
  "block.minecraft.crying_obsidian": "Ôççidiana lacrimoça",
  "block.minecraft.cut_copper": "Cobre cortao",
  "block.minecraft.cut_copper_slab": "Bardoça de cobre cortao",
  "block.minecraft.cut_copper_stairs": "Êccalerâ de cobre cortao",
  "block.minecraft.cut_red_sandstone": "Arbero colorao cortao",
  "block.minecraft.cut_red_sandstone_slab": "Bardoça d'arbero colorao cortao",
  "block.minecraft.cut_sandstone": "Arbero cortao",
  "block.minecraft.cut_sandstone_slab": "Bardoça d'arbero cortao",
  "block.minecraft.cyan_banner": "Êttandarte çian",
  "block.minecraft.cyan_bed": "Cama çian",
  "block.minecraft.cyan_candle": "Çirio çian",
  "block.minecraft.cyan_candle_cake": "Tarta con çirio çian",
  "block.minecraft.cyan_carpet": "Arfombra çian",
  "block.minecraft.cyan_concrete": "Hormigón çian",
  "block.minecraft.cyan_concrete_powder": "Çemento çian",
  "block.minecraft.cyan_glazed_terracotta": "Açuleho çian",
  "block.minecraft.cyan_shulker_box": "Caha de shulker çian",
  "block.minecraft.cyan_stained_glass": "Crîttâh tintao de çian",
  "block.minecraft.cyan_stained_glass_pane": "Panêh de crîttâh tintao de çian",
  "block.minecraft.cyan_terracotta": "Terracota çian",
  "block.minecraft.cyan_wool": "Lana çian",
  "block.minecraft.damaged_anvil": "Yunque mu dañao",
  "block.minecraft.dandelion": "Diente de león",
  "block.minecraft.dark_oak_button": "Botón de xaparro",
  "block.minecraft.dark_oak_door": "Puerta de xaparro",
  "block.minecraft.dark_oak_fence": "Berha de xaparro",
  "block.minecraft.dark_oak_fence_gate": "Cançela de xaparro",
  "block.minecraft.dark_oak_hanging_sign": "Letrero corgante de xaparro",
  "block.minecraft.dark_oak_leaves": "Ohâ de xaparro",
  "block.minecraft.dark_oak_log": "Tronco de xaparro",
  "block.minecraft.dark_oak_planks": "Tablonê de xaparro",
  "block.minecraft.dark_oak_pressure_plate": "Placa de preçión de xaparro",
  "block.minecraft.dark_oak_sapling": "Brote de xaparro",
  "block.minecraft.dark_oak_shelf": "Êttante de roble ôccuro",
  "block.minecraft.dark_oak_sign": "Letrero de xaparro",
  "block.minecraft.dark_oak_slab": "Bardoça de xaparro",
  "block.minecraft.dark_oak_stairs": "Êccalerâ de xaparro",
  "block.minecraft.dark_oak_trapdoor": "Trampiya de xaparro",
  "block.minecraft.dark_oak_wall_hanging_sign": "Letrero corgante de xaparro en paré",
  "block.minecraft.dark_oak_wall_sign": "Letrero de xaparro en paré",
  "block.minecraft.dark_oak_wood": "Leño de xaparro",
  "block.minecraft.dark_prismarine": "Prîmmarina êccura",
  "block.minecraft.dark_prismarine_slab": "Bardoça de prîmmarina êccura",
  "block.minecraft.dark_prismarine_stairs": "Êccalerâ de prîmmarina êccura",
  "block.minecraft.daylight_detector": "Çençôh de lûh çolâh",
  "block.minecraft.dead_brain_coral": "Corâh de çerebro muerto",
  "block.minecraft.dead_brain_coral_block": "Bloque de corâh de çerebro muerto",
  "block.minecraft.dead_brain_coral_fan": "Gorgonia de çerebro muerta",
  "block.minecraft.dead_brain_coral_wall_fan": "Gorgonia de çerebro muerta en paré",
  "block.minecraft.dead_bubble_coral": "Corâh de burbuha muerto",
  "block.minecraft.dead_bubble_coral_block": "Bloque de corâh de burbuha muerto",
  "block.minecraft.dead_bubble_coral_fan": "Gorgonia de burbuha muerta",
  "block.minecraft.dead_bubble_coral_wall_fan": "Gorgonia de burbuha muerta en paré",
  "block.minecraft.dead_bush": "Arbûtto muerto",
  "block.minecraft.dead_fire_coral": "Corâh de fuego muerto",
  "block.minecraft.dead_fire_coral_block": "Bloque de corâh de fuego muerto",
  "block.minecraft.dead_fire_coral_fan": "Gorgonia de fuego muerta",
  "block.minecraft.dead_fire_coral_wall_fan": "Gorgonia de fuego muerta en paré",
  "block.minecraft.dead_horn_coral": "Corâh de cuênno muerto",
  "block.minecraft.dead_horn_coral_block": "Bloque de corâh de cuênno muerto",
  "block.minecraft.dead_horn_coral_fan": "Gorgonia de cuênno muerta",
  "block.minecraft.dead_horn_coral_wall_fan": "Gorgonia de cuênno muerta en paré",
  "block.minecraft.dead_tube_coral": "Corâh de tubo muerto",
  "block.minecraft.dead_tube_coral_block": "Bloque de corâh de tubo muerto",
  "block.minecraft.dead_tube_coral_fan": "Gorgonia de tubo muerta",
  "block.minecraft.dead_tube_coral_wall_fan": "Gorgonia de tubo muerta en paré",
  "block.minecraft.decorated_pot": "Baçiha decorá",
  "block.minecraft.deepslate": "Piçarra",
  "block.minecraft.deepslate_brick_slab": "Bardoça de ladriyô de piçarra",
  "block.minecraft.deepslate_brick_stairs": "Êccalerâ de ladriyô de piçarra",
  "block.minecraft.deepslate_brick_wall": "Muro de ladriyô de piçarra",
  "block.minecraft.deepslate_bricks": "Ladriyô de piçarra",
  "block.minecraft.deepslate_coal_ore": "Beta de carbón de piçarra",
  "block.minecraft.deepslate_copper_ore": "Beta de cobre de piçarra",
  "block.minecraft.deepslate_diamond_ore": "Beta de diamante de piçarra",
  "block.minecraft.deepslate_emerald_ore": "Beta d'êmmerarda de piçarra",
  "block.minecraft.deepslate_gold_ore": "Beta d'oro de piçarra",
  "block.minecraft.deepslate_iron_ore": "Beta de yerro de piçarra",
  "block.minecraft.deepslate_lapis_ore": "Beta de lapîl-láçuli de piçarra",
  "block.minecraft.deepslate_redstone_ore": "Beta de redstone de piçarra",
  "block.minecraft.deepslate_tile_slab": "Bardoça de loçetâ de piçarra",
  "block.minecraft.deepslate_tile_stairs": "Êccalerâ de loçetâ de piçarra",
  "block.minecraft.deepslate_tile_wall": "Muro de loçetâ de piçarra",
  "block.minecraft.deepslate_tiles": "Loçetâ de piçarra",
  "block.minecraft.detector_rail": "Raîh detêttôh",
  "block.minecraft.diamond_block": "Bloque de diamante",
  "block.minecraft.diamond_ore": "Beta de diamante",
  "block.minecraft.diorite": "Diorita",
  "block.minecraft.diorite_slab": "Bardoça de diorita",
  "block.minecraft.diorite_stairs": "Êccalerâ de diorita",
  "block.minecraft.diorite_wall": "Muro de diorita",
  "block.minecraft.dirt": "Tierra",
  "block.minecraft.dirt_path": "Beréa",
  "block.minecraft.dispenser": "Dîppençadôh",
  "block.minecraft.dragon_egg": "Guebo de dragón",
  "block.minecraft.dragon_head": "Cabeça de dragón",
  "block.minecraft.dragon_wall_head": "Cabeça de dragón en paré",
  "block.minecraft.dried_ghast": "Ghast çeco",
  "block.minecraft.dried_kelp_block": "Bloque d'argâ çecâ",
  "block.minecraft.dripstone_block": "Bloque d'êppeleotema",
  "block.minecraft.dropper": "Çortadôh",
  "block.minecraft.emerald_block": "Bloque d'êmmerarda",
  "block.minecraft.emerald_ore": "Beta d'êmmerarda",
  "block.minecraft.enchanting_table": "Meça d'encantamientô",
  "block.minecraft.end_gateway": "Âççeço al End",
  "block.minecraft.end_portal": "Portâh del End",
  "block.minecraft.end_portal_frame": "Marco der portâh del End",
  "block.minecraft.end_rod": "Bara del End",
  "block.minecraft.end_stone": "Roca del End",
  "block.minecraft.end_stone_brick_slab": "Bardoça de ladriyô de roca del End",
  "block.minecraft.end_stone_brick_stairs": "Êccalerâ de ladriyô de roca del End",
  "block.minecraft.end_stone_brick_wall": "Muro de ladriyô de roca del End",
  "block.minecraft.end_stone_bricks": "Ladriyô de roca del End",
  "block.minecraft.ender_chest": "Baûh d'Ender",
  "block.minecraft.exposed_chiseled_copper": "Cobre çinçelao êppuêtto",
  "block.minecraft.exposed_copper": "Cobre êppuêtto",
  "block.minecraft.exposed_copper_bars": "Barrotê de cobre êppuêtto",
  "block.minecraft.exposed_copper_bulb": "Lámpa de cobre êppuêtto",
  "block.minecraft.exposed_copper_chain": "Cadena de cobre êppuêtto",
  "block.minecraft.exposed_copper_chest": "Cofre de cobre êppuêtto",
  "block.minecraft.exposed_copper_door": "Puerta de cobre êppuêtto",
  "block.minecraft.exposed_copper_golem_statue": "Êttatua de gólem de cobre êppuêtto",
  "block.minecraft.exposed_copper_grate": "Rejiya de cobre êppuêtto",
  "block.minecraft.exposed_copper_lantern": "Farôh de cobre êppuêtto",
  "block.minecraft.exposed_copper_trapdoor": "Trampiya de cobre êppuêtto",
  "block.minecraft.exposed_cut_copper": "Cobre cortao êppuêtto",
  "block.minecraft.exposed_cut_copper_slab": "Bardoça de cobre cortao êppuêtto",
  "block.minecraft.exposed_cut_copper_stairs": "Êccalerâ de cobre cortao êppuêtto",
  "block.minecraft.exposed_lightning_rod": "Pararrayô êppuêtto",
  "block.minecraft.farmland": "Tierra de curtibo",
  "block.minecraft.fern": "Helexo",
  "block.minecraft.fire": "Fuego",
  "block.minecraft.fire_coral": "Corâh de fuego",
  "block.minecraft.fire_coral_block": "Bloque de corâh de fuego",
  "block.minecraft.fire_coral_fan": "Gorgonia de fuego",
  "block.minecraft.fire_coral_wall_fan": "Gorgonia de fuego en paré",
  "block.minecraft.firefly_bush": "Arbûtto de luçiérganâ",
  "block.minecraft.fletching_table": "Meça de flexâ",
  "block.minecraft.flower_pot": "Tiêtto",
  "block.minecraft.flowering_azalea": "Açalea en flôh",
  "block.minecraft.flowering_azalea_leaves": "Ohâ d'açalea en flôh",
  "block.minecraft.frogspawn": "Guebâ de rana",
  "block.minecraft.frosted_ice": "Êccarxa",
  "block.minecraft.furnace": "Hônno",
  "block.minecraft.gilded_blackstone": "Açabaxe áureo",
  "block.minecraft.glass": "Crîttâh",
  "block.minecraft.glass_pane": "Panêh de crîttâh",
  "block.minecraft.glow_lichen": "Liquen briyante",
  "block.minecraft.glowstone": "Roca briyante",
  "block.minecraft.gold_block": "Bloque d'oro",
  "block.minecraft.gold_ore": "Beta d'oro",
  "block.minecraft.golden_dandelion": "Diente de león dorao",
  "block.minecraft.granite": "Granito",
  "block.minecraft.granite_slab": "Bardoça de granito",
  "block.minecraft.granite_stairs": "Êccalerâ de granito",
  "block.minecraft.granite_wall": "Muro de granito",
  "block.minecraft.grass": "Yerba",
  "block.minecraft.grass_block": "Bloque de yerba",
  "block.minecraft.gravel": "Çaorra",
  "block.minecraft.gray_banner": "Êttandarte grîh",
  "block.minecraft.gray_bed": "Cama grîh",
  "block.minecraft.gray_candle": "Çirio grîh",
  "block.minecraft.gray_candle_cake": "Tarta con çirio grîh",
  "block.minecraft.gray_carpet": "Arfombra grîh",
  "block.minecraft.gray_concrete": "Hormigón grîh",
  "block.minecraft.gray_concrete_powder": "Çemento grîh",
  "block.minecraft.gray_glazed_terracotta": "Açuleho grîh",
  "block.minecraft.gray_shulker_box": "Caha de shulker grîh",
  "block.minecraft.gray_stained_glass": "Crîttâh tintao de grîh",
  "block.minecraft.gray_stained_glass_pane": "Panêh de crîttâh tintao de grîh",
  "block.minecraft.gray_terracotta": "Terracota grîh",
  "block.minecraft.gray_wool": "Lana grîh",
  "block.minecraft.green_banner": "Êttandarte berde",
  "block.minecraft.green_bed": "Cama berde",
  "block.minecraft.green_candle": "Çirio berde",
  "block.minecraft.green_candle_cake": "Tarta con çirio berde",
  "block.minecraft.green_carpet": "Arfombra berde",
  "block.minecraft.green_concrete": "Hormigón berde",
  "block.minecraft.green_concrete_powder": "Çemento berde",
  "block.minecraft.green_glazed_terracotta": "Açuleho berde",
  "block.minecraft.green_shulker_box": "Caha de shulker berde",
  "block.minecraft.green_stained_glass": "Crîttâh tintao de berde",
  "block.minecraft.green_stained_glass_pane": "Panêh de crîttâh tintao de berde",
  "block.minecraft.green_terracotta": "Terracota berde",
  "block.minecraft.green_wool": "Lana berde",
  "block.minecraft.grindstone": "Muela d'afilâh",
  "block.minecraft.hanging_roots": "Raíçê corgantê",
  "block.minecraft.hay_block": "Arpaca de paha",
  "block.minecraft.heavy_core": "Núcleo peçao",
  "block.minecraft.heavy_weighted_pressure_plate": "Placa de preçión pa peço elebao",
  "block.minecraft.honey_block": "Bloque de miêh",
  "block.minecraft.honeycomb_block": "Bloque de panâh",
  "block.minecraft.hopper": "Torba",
  "block.minecraft.horn_coral": "Corâh de cuênno",
  "block.minecraft.horn_coral_block": "Bloque de corâh de cuênno",
  "block.minecraft.horn_coral_fan": "Gorgonia de cuênno",
  "block.minecraft.horn_coral_wall_fan": "Gorgonia de cuênno en paré",
  "block.minecraft.ice": "Yelo",
  "block.minecraft.infested_chiseled_stone_bricks": "Ladriyô de roca êccurpía infêttá",
  "block.minecraft.infested_cobblestone": "Adoquín infêttáo",
  "block.minecraft.infested_cracked_stone_bricks": "Ladriyô de roca rêqquebrahá infêttá",
  "block.minecraft.infested_deepslate": "Piçarra infêttá",
  "block.minecraft.infested_mossy_stone_bricks": "Ladriyô de roca mûggoça infêttá",
  "block.minecraft.infested_stone": "Roca infêttá",
  "block.minecraft.infested_stone_bricks": "Ladriyô de roca infêttá",
  "block.minecraft.iron_bars": "Barrotê de yerro",
  "block.minecraft.iron_block": "Bloque de yerro",
  "block.minecraft.iron_chain": "Cadena de ierro",
  "block.minecraft.iron_door": "Puerta de yerro",
  "block.minecraft.iron_ore": "Beta de yerro",
  "block.minecraft.iron_trapdoor": "Trampiya de yerro",
  "block.minecraft.jack_o_lantern": "Calabaça de Toçantô",
  "block.minecraft.jigsaw": "Bloque rompecabeçâ",
  "block.minecraft.jukebox": "Tocadîccô",
  "block.minecraft.jungle_button": "Botón de hungla",
  "block.minecraft.jungle_door": "Puerta de hungla",
  "block.minecraft.jungle_fence": "Berha de hungla",
  "block.minecraft.jungle_fence_gate": "Cançela de hungla",
  "block.minecraft.jungle_hanging_sign": "Letrero corgante de hungla",
  "block.minecraft.jungle_leaves": "Ohâ de hungla",
  "block.minecraft.jungle_log": "Tronco de hungla",
  "block.minecraft.jungle_planks": "Tablonê de hungla",
  "block.minecraft.jungle_pressure_plate": "Placa de preçión de hungla",
  "block.minecraft.jungle_sapling": "Brote de hungla",
  "block.minecraft.jungle_shelf": "Êttante de hungla",
  "block.minecraft.jungle_sign": "Letrero de hungla",
  "block.minecraft.jungle_slab": "Bardoça de hungla",
  "block.minecraft.jungle_stairs": "Êccalerâ de hungla",
  "block.minecraft.jungle_trapdoor": "Trampiya de hungla",
  "block.minecraft.jungle_wall_hanging_sign": "Letrero corgante de hungla en paré",
  "block.minecraft.jungle_wall_sign": "Letrero de hungla en paré",
  "block.minecraft.jungle_wood": "Leño de hungla",
  "block.minecraft.kelp": "Arga",
  "block.minecraft.kelp_plant": "Tayo d'arga",
  "block.minecraft.ladder": "Êccalera de mano",
  "block.minecraft.lantern": "Faroliyo",
  "block.minecraft.lapis_block": "Bloque de lapîl-láçuli",
  "block.minecraft.lapis_ore": "Beta de lapîl-láçuli",
  "block.minecraft.large_amethyst_bud": "Crîttâh d'ametîtta grande",
  "block.minecraft.large_fern": "Helexo grande",
  "block.minecraft.lava": "Laba",
  "block.minecraft.lava_cauldron": "Cardero de laba",
  "block.minecraft.leaf_litter": "Ohâ secâ",
  "block.minecraft.lectern": "Atrîh",
  "block.minecraft.lever": "Palanca",
  "block.minecraft.light": "Lûh",
  "block.minecraft.light_blue_banner": "Êttandarte açûh claro",
  "block.minecraft.light_blue_bed": "Cama açûh claro",
  "block.minecraft.light_blue_candle": "Çirio açûh claro",
  "block.minecraft.light_blue_candle_cake": "Tarta con çirio açûh claro",
  "block.minecraft.light_blue_carpet": "Arfombra açûh claro",
  "block.minecraft.light_blue_concrete": "Hormigón açûh claro",
  "block.minecraft.light_blue_concrete_powder": "Çemento açûh claro",
  "block.minecraft.light_blue_glazed_terracotta": "Açuleho açûh claro",
  "block.minecraft.light_blue_shulker_box": "Caha de shulker açûh claro",
  "block.minecraft.light_blue_stained_glass": "Crîttâh tintao d'açûh claro",
  "block.minecraft.light_blue_stained_glass_pane": "Panêh de crîttâh tintao d'açûh claro",
  "block.minecraft.light_blue_terracotta": "Terracota açûh claro",
  "block.minecraft.light_blue_wool": "Lana açûh claro",
  "block.minecraft.light_gray_banner": "Êttandarte grîh claro",
  "block.minecraft.light_gray_bed": "Cama grîh claro",
  "block.minecraft.light_gray_candle": "Çirio grîh claro",
  "block.minecraft.light_gray_candle_cake": "Tarta con çirio grîh claro",
  "block.minecraft.light_gray_carpet": "Arfombra grîh claro",
  "block.minecraft.light_gray_concrete": "Hormigón grîh claro",
  "block.minecraft.light_gray_concrete_powder": "Çemento grîh claro",
  "block.minecraft.light_gray_glazed_terracotta": "Açuleho grîh claro",
  "block.minecraft.light_gray_shulker_box": "Caha de shulker grîh claro",
  "block.minecraft.light_gray_stained_glass": "Crîttâh tintao de grîh claro",
  "block.minecraft.light_gray_stained_glass_pane": "Panêh de crîttâh tintao de grîh claro",
  "block.minecraft.light_gray_terracotta": "Terracota grîh claro",
  "block.minecraft.light_gray_wool": "Lana grîh claro",
  "block.minecraft.light_weighted_pressure_plate": "Placa de preçión pa peço lihero",
  "block.minecraft.lightning_rod": "Pararrayô",
  "block.minecraft.lilac": "Lila",
  "block.minecraft.lily_of_the_valley": "Lirio der baye",
  "block.minecraft.lily_pad": "Nenúfâ",
  "block.minecraft.lime_banner": "Êttandarte lima",
  "block.minecraft.lime_bed": "Cama lima",
  "block.minecraft.lime_candle": "Çirio lima",
  "block.minecraft.lime_candle_cake": "Tarta con çirio lima",
  "block.minecraft.lime_carpet": "Arfombra lima",
  "block.minecraft.lime_concrete": "Hormigón lima",
  "block.minecraft.lime_concrete_powder": "Çemento lima",
  "block.minecraft.lime_glazed_terracotta": "Açuleho lima",
  "block.minecraft.lime_shulker_box": "Caha de shulker lima",
  "block.minecraft.lime_stained_glass": "Crîttâh tintao de lima",
  "block.minecraft.lime_stained_glass_pane": "Panêh de crîttâh tintao de lima",
  "block.minecraft.lime_terracotta": "Terracota lima",
  "block.minecraft.lime_wool": "Lana lima",
  "block.minecraft.lodestone": "Mânnetita",
  "block.minecraft.loom": "Telâh",
  "block.minecraft.magenta_banner": "Êttandarte mahenta",
  "block.minecraft.magenta_bed": "Cama mahenta",
  "block.minecraft.magenta_candle": "Çirio mahenta",
  "block.minecraft.magenta_candle_cake": "Tarta con çirio mahenta",
  "block.minecraft.magenta_carpet": "Arfombra mahenta",
  "block.minecraft.magenta_concrete": "Hormigón mahenta",
  "block.minecraft.magenta_concrete_powder": "Çemento mahenta",
  "block.minecraft.magenta_glazed_terracotta": "Açuleho mahenta",
  "block.minecraft.magenta_shulker_box": "Caha de shulker mahenta",
  "block.minecraft.magenta_stained_glass": "Crîttâh tintao de mahenta",
  "block.minecraft.magenta_stained_glass_pane": "Panêh de crîttâh tintao de mahenta",
  "block.minecraft.magenta_terracotta": "Terracota mahenta",
  "block.minecraft.magenta_wool": "Lana mahenta",
  "block.minecraft.magma_block": "Bloque de mâmma",
  "block.minecraft.mangrove_button": "Botón de mangle",
  "block.minecraft.mangrove_door": "Puerta de mangle",
  "block.minecraft.mangrove_fence": "Berha de mangle",
  "block.minecraft.mangrove_fence_gate": "Cançela de mangle",
  "block.minecraft.mangrove_hanging_sign": "Letrero corgante de mangle",
  "block.minecraft.mangrove_leaves": "Ohâ de mangle",
  "block.minecraft.mangrove_log": "Tronco de mangle",
  "block.minecraft.mangrove_planks": "Tablonê de mangle",
  "block.minecraft.mangrove_pressure_plate": "Placa de preçión de mangle",
  "block.minecraft.mangrove_propagule": "Propágulo de mangle",
  "block.minecraft.mangrove_roots": "Raíçê de mangle",
  "block.minecraft.mangrove_shelf": "Êttante de mangle",
  "block.minecraft.mangrove_sign": "Letrero de mangle",
  "block.minecraft.mangrove_slab": "Bardoça de mangle",
  "block.minecraft.mangrove_stairs": "Êccalerâ de mangle",
  "block.minecraft.mangrove_trapdoor": "Trampiya de mangle",
  "block.minecraft.mangrove_wall_hanging_sign": "Letrero corgante de mangle en paré",
  "block.minecraft.mangrove_wall_sign": "Letrero de mangle en paré",
  "block.minecraft.mangrove_wood": "Leño de mangle",
  "block.minecraft.medium_amethyst_bud": "Crîttâh d'ametîtta mediano",
  "block.minecraft.melon": "Açendía",
  "block.minecraft.melon_stem": "Tayo d'açendía",
  "block.minecraft.moss_block": "Bloque de mûggo",
  "block.minecraft.moss_carpet": "Arfombra de mûggo",
  "block.minecraft.mossy_cobblestone": "Adoquín mûggoço",
  "block.minecraft.mossy_cobblestone_slab": "Bardoça d'adoquín mûggoço",
  "block.minecraft.mossy_cobblestone_stairs": "Êccalerâ d'adoquín mûggoço",
  "block.minecraft.mossy_cobblestone_wall": "Muro d'adoquín mûggoço",
  "block.minecraft.mossy_stone_brick_slab": "Bardoça de ladriyô de roca mûggoça",
  "block.minecraft.mossy_stone_brick_stairs": "Êccalerâ de ladriyô de roca mûggoça",
  "block.minecraft.mossy_stone_brick_wall": "Muro de ladriyô de roca mûggoça",
  "block.minecraft.mossy_stone_bricks": "Ladriyô de roca mûggoça",
  "block.minecraft.moving_piston": "Pîttón en mobimiento",
  "block.minecraft.mud": "Fango",
  "block.minecraft.mud_brick_slab": "Bardoça de ladriyô d'adobe",
  "block.minecraft.mud_brick_stairs": "Êccalerâ de ladriyô d'adobe",
  "block.minecraft.mud_brick_wall": "Muro de ladriyô d'adobe",
  "block.minecraft.mud_bricks": "Ladriyô d'adobe",
  "block.minecraft.muddy_mangrove_roots": "Raíçê de mangle enfangâh",
  "block.minecraft.mushroom_stem": "Tayo de gurumelo",
  "block.minecraft.mycelium": "Miçelio",
  "block.minecraft.nether_brick_fence": "Berha de ladriyô der Nether",
  "block.minecraft.nether_brick_slab": "Bardoça de ladriyô der Nether",
  "block.minecraft.nether_brick_stairs": "Êccalerâ de ladriyô der Nether",
  "block.minecraft.nether_brick_wall": "Muro de ladriyô der Nether",
  "block.minecraft.nether_bricks": "Ladriyô der Nether",
  "block.minecraft.nether_gold_ore": "Beta d'oro der Nether",
  "block.minecraft.nether_portal": "Portâh ar Nether",
  "block.minecraft.nether_quartz_ore": "Beta de cuarço der Nether",
  "block.minecraft.nether_sprouts": "Brotê der Nether",
  "block.minecraft.nether_wart": "Berruga der Nether",
  "block.minecraft.nether_wart_block": "Bloque de berrugâ der Nether",
  "block.minecraft.netherite_block": "Bloque de netherita",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Bloque muçicâh",
  "block.minecraft.oak_button": "Botón de quehigo",
  "block.minecraft.oak_door": "Puerta de quehigo",
  "block.minecraft.oak_fence": "Berha de quehigo",
  "block.minecraft.oak_fence_gate": "Cançela de quehigo",
  "block.minecraft.oak_hanging_sign": "Letrero corgante de quehigo",
  "block.minecraft.oak_leaves": "Ohâ de quehigo",
  "block.minecraft.oak_log": "Tronco de quehigo",
  "block.minecraft.oak_planks": "Tablonê de quehigo",
  "block.minecraft.oak_pressure_plate": "Placa de preçión de quehigo",
  "block.minecraft.oak_sapling": "Brote de quehigo",
  "block.minecraft.oak_shelf": "Êttante de roble",
  "block.minecraft.oak_sign": "Letrero de quehigo",
  "block.minecraft.oak_slab": "Bardoça de quehigo",
  "block.minecraft.oak_stairs": "Êccalerâ de quehigo",
  "block.minecraft.oak_trapdoor": "Trampiya de quehigo",
  "block.minecraft.oak_wall_hanging_sign": "Letrero corgante de quehigo en paré",
  "block.minecraft.oak_wall_sign": "Letrero de quehigo en paré",
  "block.minecraft.oak_wood": "Leño de quehigo",
  "block.minecraft.observer": "Ôççerbadôh",
  "block.minecraft.obsidian": "Ôççidiana",
  "block.minecraft.ochre_froglight": "Linterana ocre",
  "block.minecraft.ominous_banner": "Êttandarte nefâtto",
  "block.minecraft.open_eyeblossom": "Oho-ê pêtalo abietto",
  "block.minecraft.orange_banner": "Êttandarte naranha",
  "block.minecraft.orange_bed": "Cama naranha",
  "block.minecraft.orange_candle": "Çirio naranha",
  "block.minecraft.orange_candle_cake": "Tarta con çirio naranha",
  "block.minecraft.orange_carpet": "Arfombra naranha",
  "block.minecraft.orange_concrete": "Hormigón naranha",
  "block.minecraft.orange_concrete_powder": "Çemento naranha",
  "block.minecraft.orange_glazed_terracotta": "Açuleho naranha",
  "block.minecraft.orange_shulker_box": "Caha de shulker naranha",
  "block.minecraft.orange_stained_glass": "Crîttâh tintao de naranha",
  "block.minecraft.orange_stained_glass_pane": "Panêh de crîttâh tintao de naranha",
  "block.minecraft.orange_terracotta": "Terracota naranha",
  "block.minecraft.orange_tulip": "Tulipán naranha",
  "block.minecraft.orange_wool": "Lana naranha",
  "block.minecraft.oxeye_daisy": "Margarita",
  "block.minecraft.oxidized_chiseled_copper": "Cobre çinçelao ôççidao",
  "block.minecraft.oxidized_copper": "Cobre ôççidao",
  "block.minecraft.oxidized_copper_bars": "Barrotê de cobre ôççidao",
  "block.minecraft.oxidized_copper_bulb": "Lámpa de cobre ôççidao",
  "block.minecraft.oxidized_copper_chain": "Cadena de cobre ôççidao",
  "block.minecraft.oxidized_copper_chest": "Cofre de cobre ôççidao",
  "block.minecraft.oxidized_copper_door": "Puerta de cobre ôççidao",
  "block.minecraft.oxidized_copper_golem_statue": "Êttatua de gólem de cobre ôççidao",
  "block.minecraft.oxidized_copper_grate": "Rehiya de cobre ôççidao",
  "block.minecraft.oxidized_copper_lantern": "Farôh de cobre ôççidao",
  "block.minecraft.oxidized_copper_trapdoor": "Trampiya de cobre ôççidao",
  "block.minecraft.oxidized_cut_copper": "Cobre cortao ôççidao",
  "block.minecraft.oxidized_cut_copper_slab": "Bardoça de cobre cortao ôççidao",
  "block.minecraft.oxidized_cut_copper_stairs": "Êccalerâ de cobre cortao ôççidao",
  "block.minecraft.oxidized_lightning_rod": "Pararrayô ôççidao",
  "block.minecraft.packed_ice": "Yelo compâttao",
  "block.minecraft.packed_mud": "Adobe",
  "block.minecraft.pale_hanging_moss": "Mûggo pálido corgante",
  "block.minecraft.pale_moss_block": "Mûggo pálido",
  "block.minecraft.pale_moss_carpet": "Arfombra de mûggo pálido",
  "block.minecraft.pale_oak_button": "Botón de quehigo pálido",
  "block.minecraft.pale_oak_door": "Puerta de quehigo pálido",
  "block.minecraft.pale_oak_fence": "Berha de quehigo pálido",
  "block.minecraft.pale_oak_fence_gate": "Cançela de quehigo pálido",
  "block.minecraft.pale_oak_hanging_sign": "Letrero corgante de quehigo pálido",
  "block.minecraft.pale_oak_leaves": "Ohâ de quehigo pálido",
  "block.minecraft.pale_oak_log": "Tronco de quehigo pálido",
  "block.minecraft.pale_oak_planks": "Tablonê de quehigo pálido",
  "block.minecraft.pale_oak_pressure_plate": "Placa de preçión de quehigo pálido",
  "block.minecraft.pale_oak_sapling": "Brote de quehigo pálido",
  "block.minecraft.pale_oak_shelf": "Êttante de roble pálido",
  "block.minecraft.pale_oak_sign": "Letrero de quehigo pálido",
  "block.minecraft.pale_oak_slab": "Bardoça de quehigo pálido",
  "block.minecraft.pale_oak_stairs": "Êccalerâ de quehigo pálido",
  "block.minecraft.pale_oak_trapdoor": "Trampiya de quehigo pálido",
  "block.minecraft.pale_oak_wall_hanging_sign": "Letrero corgante de quehigo pálido en paré",
  "block.minecraft.pale_oak_wall_sign": "Letrero de quehigo pálido en paré",
  "block.minecraft.pale_oak_wood": "Leño de quehigo pálido",
  "block.minecraft.pearlescent_froglight": "Linterana nacará",
  "block.minecraft.peony": "Peonía",
  "block.minecraft.petrified_oak_slab": "Bardoça de quehigo petrificao",
  "block.minecraft.piglin_head": "Cabeça de piglin",
  "block.minecraft.piglin_wall_head": "Cabeça de piglin en paré",
  "block.minecraft.pink_banner": "Êttandarte roça",
  "block.minecraft.pink_bed": "Cama roça",
  "block.minecraft.pink_candle": "Çirio roça",
  "block.minecraft.pink_candle_cake": "Tarta con çirio roça",
  "block.minecraft.pink_carpet": "Arfombra roça",
  "block.minecraft.pink_concrete": "Hormigón roça",
  "block.minecraft.pink_concrete_powder": "Çemento roça",
  "block.minecraft.pink_glazed_terracotta": "Açuleho roça",
  "block.minecraft.pink_petals": "Pétalô roçâ",
  "block.minecraft.pink_shulker_box": "Caha de shulker roça",
  "block.minecraft.pink_stained_glass": "Crîttâh tintao de roça",
  "block.minecraft.pink_stained_glass_pane": "Panêh de crîttâh tintao de roça",
  "block.minecraft.pink_terracotta": "Terracota roça",
  "block.minecraft.pink_tulip": "Tulipán roça",
  "block.minecraft.pink_wool": "Lana roça",
  "block.minecraft.piston": "Pîttón",
  "block.minecraft.piston_head": "Cabeça de pîttón",
  "block.minecraft.pitcher_crop": "Curtibo de planta odre",
  "block.minecraft.pitcher_plant": "Planta odre",
  "block.minecraft.player_head": "Cabeça de hugadôh",
  "block.minecraft.player_head.named": "Cabeça de %s",
  "block.minecraft.player_wall_head": "Cabeça de hugadôh en paré",
  "block.minecraft.podzol": "Podçol",
  "block.minecraft.pointed_dripstone": "Êppeleotema afilao",
  "block.minecraft.polished_andesite": "Andeçita pulía",
  "block.minecraft.polished_andesite_slab": "Bardoça d'andeçita pulía",
  "block.minecraft.polished_andesite_stairs": "Êccalerâ d'andeçita pulía",
  "block.minecraft.polished_basalt": "Baçarto pulío",
  "block.minecraft.polished_blackstone": "Açabaxe pulío",
  "block.minecraft.polished_blackstone_brick_slab": "Bardoça de ladriyô d'açabaxe pulío",
  "block.minecraft.polished_blackstone_brick_stairs": "Êccalerâ de ladriyô d'açabaxe pulío",
  "block.minecraft.polished_blackstone_brick_wall": "Muro de ladriyô d'açabaxe pulío",
  "block.minecraft.polished_blackstone_bricks": "Ladriyô d'açabaxe pulío",
  "block.minecraft.polished_blackstone_button": "Botón d'açabaxe pulío",
  "block.minecraft.polished_blackstone_pressure_plate": "Placa de preçión d'açabaxe pulío",
  "block.minecraft.polished_blackstone_slab": "Bardoça d'açabaxe pulío",
  "block.minecraft.polished_blackstone_stairs": "Êccalerâ d'açabaxe pulío",
  "block.minecraft.polished_blackstone_wall": "Muro d'açabaxe pulío",
  "block.minecraft.polished_deepslate": "Piçarra pulía",
  "block.minecraft.polished_deepslate_slab": "Bardoça de piçarra pulía",
  "block.minecraft.polished_deepslate_stairs": "Êccalerâ de piçarra pulía",
  "block.minecraft.polished_deepslate_wall": "Muro de piçarra pulía",
  "block.minecraft.polished_diorite": "Diorita pulía",
  "block.minecraft.polished_diorite_slab": "Bardoça de diorita pulía",
  "block.minecraft.polished_diorite_stairs": "Êccalerâ de diorita pulía",
  "block.minecraft.polished_granite": "Granito pulío",
  "block.minecraft.polished_granite_slab": "Bardoça de granito pulío",
  "block.minecraft.polished_granite_stairs": "Êccalerâ de granito pulío",
  "block.minecraft.polished_tuff": "Toba pulía",
  "block.minecraft.polished_tuff_slab": "Loça de toba pulía",
  "block.minecraft.polished_tuff_stairs": "Êccalerâ de toba pulía",
  "block.minecraft.polished_tuff_wall": "Muro de toba pulía",
  "block.minecraft.poppy": "Amapola",
  "block.minecraft.potatoes": "Papâ",
  "block.minecraft.potted_acacia_sapling": "Tiêtto con brote de mimoça",
  "block.minecraft.potted_allium": "Tiêtto con allium",
  "block.minecraft.potted_azalea_bush": "Tiêtto con açalea",
  "block.minecraft.potted_azure_bluet": "Tiêtto con rubiáçea",
  "block.minecraft.potted_bamboo": "Tiêtto con bambú",
  "block.minecraft.potted_birch_sapling": "Tiêtto con brote de xopo",
  "block.minecraft.potted_blue_orchid": "Tiêtto con orquídia açûh",
  "block.minecraft.potted_brown_mushroom": "Tiêtto con gurumelo marrón",
  "block.minecraft.potted_cactus": "Tiêtto con câttû",
  "block.minecraft.potted_cherry_sapling": "Tiêtto con brote de çereço",
  "block.minecraft.potted_closed_eyeblossom": "Flô d'óho çerrâh",
  "block.minecraft.potted_cornflower": "Tiêtto con açiano",
  "block.minecraft.potted_crimson_fungus": "Tiêtto con hongo carmeçí",
  "block.minecraft.potted_crimson_roots": "Tiêtto con raíçê carmeçíê",
  "block.minecraft.potted_dandelion": "Tiêtto con diente de león",
  "block.minecraft.potted_dark_oak_sapling": "Tiêtto con brote de xaparro",
  "block.minecraft.potted_dead_bush": "Tiêtto con arbûtto çeco",
  "block.minecraft.potted_fern": "Tiêtto con helexo",
  "block.minecraft.potted_flowering_azalea_bush": "Tiêtto con açalea en flôh",
  "block.minecraft.potted_golden_dandelion": "Maçeta con diente de león dorao",
  "block.minecraft.potted_jungle_sapling": "Tiêtto con brote de hungla",
  "block.minecraft.potted_lily_of_the_valley": "Tiêtto con lirio der baye",
  "block.minecraft.potted_mangrove_propagule": "Tiêtto con propágulo de mangle",
  "block.minecraft.potted_oak_sapling": "Tiêtto con brote de quehigo",
  "block.minecraft.potted_open_eyeblossom": "Flô d'óho abiêttah",
  "block.minecraft.potted_orange_tulip": "Tiêtto con tulipán naranha",
  "block.minecraft.potted_oxeye_daisy": "Tiêtto con margarita",
  "block.minecraft.potted_pale_oak_sapling": "Tiêtto con brote de quehigo pálido",
  "block.minecraft.potted_pink_tulip": "Tiêtto con tulipán roça",
  "block.minecraft.potted_poppy": "Tiêtto con amapola",
  "block.minecraft.potted_red_mushroom": "Tiêtto con gurumelo colorao",
  "block.minecraft.potted_red_tulip": "Tiêtto con tulipán colorao",
  "block.minecraft.potted_spruce_sapling": "Tiêtto con brote de pinçapo",
  "block.minecraft.potted_torchflower": "Tiêtto con plantorxa",
  "block.minecraft.potted_warped_fungus": "Tiêtto con hongo êttrambótico",
  "block.minecraft.potted_warped_roots": "Tiêtto con raíçê êttrambóticâ",
  "block.minecraft.potted_white_tulip": "Tiêtto con tulipán blanco",
  "block.minecraft.potted_wither_rose": "Tiêtto con roça de Wither",
  "block.minecraft.powder_snow": "Niebe porbo",
  "block.minecraft.powder_snow_cauldron": "Cardero de niebe porbo",
  "block.minecraft.powered_rail": "Raîh propurçôh",
  "block.minecraft.prismarine": "Prîmmarina",
  "block.minecraft.prismarine_brick_slab": "Bardoça de ladriyô de prîmmarina",
  "block.minecraft.prismarine_brick_stairs": "Êccalerâ de ladriyô de prîmmarina",
  "block.minecraft.prismarine_bricks": "Ladriyô de prîmmarina",
  "block.minecraft.prismarine_slab": "Bardoça de prîmmarina",
  "block.minecraft.prismarine_stairs": "Êccalerâ de prîmmarina",
  "block.minecraft.prismarine_wall": "Muro de prîmmarina",
  "block.minecraft.pumpkin": "Calabaça",
  "block.minecraft.pumpkin_stem": "Tayo de calabaça",
  "block.minecraft.purple_banner": "Êttandarte morao",
  "block.minecraft.purple_bed": "Cama morá",
  "block.minecraft.purple_candle": "Çirio morao",
  "block.minecraft.purple_candle_cake": "Tarta con çirio morao",
  "block.minecraft.purple_carpet": "Arfombra morá",
  "block.minecraft.purple_concrete": "Hormigón morao",
  "block.minecraft.purple_concrete_powder": "Çemento morao",
  "block.minecraft.purple_glazed_terracotta": "Açuleho morao",
  "block.minecraft.purple_shulker_box": "Caha de shulker morá",
  "block.minecraft.purple_stained_glass": "Crîttâh tintao de morao",
  "block.minecraft.purple_stained_glass_pane": "Panêh de crîttâh tintao de morao",
  "block.minecraft.purple_terracotta": "Terracota morá",
  "block.minecraft.purple_wool": "Lana morá",
  "block.minecraft.purpur_block": "Bloque de púrpur",
  "block.minecraft.purpur_pillar": "Pilâh de púrpur",
  "block.minecraft.purpur_slab": "Bardoça de púrpur",
  "block.minecraft.purpur_stairs": "Êccalerâ de púrpur",
  "block.minecraft.quartz_block": "Bloque de cuarço",
  "block.minecraft.quartz_bricks": "Ladriyô de cuarço",
  "block.minecraft.quartz_pillar": "Pilâh de cuarço",
  "block.minecraft.quartz_slab": "Bardoça de cuarço",
  "block.minecraft.quartz_stairs": "Êccalerâ de cuarço",
  "block.minecraft.rail": "Raîh",
  "block.minecraft.raw_copper_block": "Bloque de minerâh de cobre",
  "block.minecraft.raw_gold_block": "Bloque de minerâh d'oro",
  "block.minecraft.raw_iron_block": "Bloque de minerâh de yerro",
  "block.minecraft.red_banner": "Êttandarte colorao",
  "block.minecraft.red_bed": "Cama colorá",
  "block.minecraft.red_candle": "Çirio colorao",
  "block.minecraft.red_candle_cake": "Tarta con çirio colorao",
  "block.minecraft.red_carpet": "Arfombra colorá",
  "block.minecraft.red_concrete": "Hormigón colorao",
  "block.minecraft.red_concrete_powder": "Çemento colorao",
  "block.minecraft.red_glazed_terracotta": "Açuleho colorao",
  "block.minecraft.red_mushroom": "Gurumelo colorao",
  "block.minecraft.red_mushroom_block": "Bloque de gurumelo colorao",
  "block.minecraft.red_nether_brick_slab": "Bardoça de ladriyô der Nether coloraô",
  "block.minecraft.red_nether_brick_stairs": "Êccalerâ de ladriyô der Nether coloraô",
  "block.minecraft.red_nether_brick_wall": "Muro de ladriyô der Nether coloraô",
  "block.minecraft.red_nether_bricks": "Ladriyô der Nether coloraô",
  "block.minecraft.red_sand": "Arena colorá",
  "block.minecraft.red_sandstone": "Arbero colorao",
  "block.minecraft.red_sandstone_slab": "Bardoça d'arbero colorao",
  "block.minecraft.red_sandstone_stairs": "Êccalerâ d'arbero colorao",
  "block.minecraft.red_sandstone_wall": "Muro d'arbero colorao",
  "block.minecraft.red_shulker_box": "Caha de shulker colorá",
  "block.minecraft.red_stained_glass": "Crîttâh tintao de colorao",
  "block.minecraft.red_stained_glass_pane": "Panêh de crîttâh tintao de colorao",
  "block.minecraft.red_terracotta": "Terracota colorá",
  "block.minecraft.red_tulip": "Tulipán colorao",
  "block.minecraft.red_wool": "Lana colorá",
  "block.minecraft.redstone_block": "Bloque de redstone",
  "block.minecraft.redstone_lamp": "Lámpara de redstone",
  "block.minecraft.redstone_ore": "Beta de redstone",
  "block.minecraft.redstone_torch": "Antorxa de redstone",
  "block.minecraft.redstone_wall_torch": "Antorxa de redstone en paré",
  "block.minecraft.redstone_wire": "Cable de redstone",
  "block.minecraft.reinforced_deepslate": "Piçarra reforçá",
  "block.minecraft.repeater": "Repetidôh de redstone",
  "block.minecraft.repeating_command_block": "Bloque de comandô iteratibo",
  "block.minecraft.resin_block": "Blôque de reçinah",
  "block.minecraft.resin_brick_slab": "Loça-ê bloque-ê reçina",
  "block.minecraft.resin_brick_stairs": "Eccalerah-ê bloque-ê reçina",
  "block.minecraft.resin_brick_wall": "Paré de ladrillo de resina",
  "block.minecraft.resin_bricks": "Bloqueh-ê resina",
  "block.minecraft.resin_clump": "Grumo de resina",
  "block.minecraft.respawn_anchor": "Áncora de reapariçión",
  "block.minecraft.rooted_dirt": "Tierra enraiçá",
  "block.minecraft.rose_bush": "Roçâh",
  "block.minecraft.sand": "Arena",
  "block.minecraft.sandstone": "Arbero",
  "block.minecraft.sandstone_slab": "Bardoça d'arbero",
  "block.minecraft.sandstone_stairs": "Êccalerâ d'arbero",
  "block.minecraft.sandstone_wall": "Muro d'arbero",
  "block.minecraft.scaffolding": "Andamio",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Cataliçadôh de sculk",
  "block.minecraft.sculk_sensor": "Çençôh de sculk",
  "block.minecraft.sculk_shrieker": "Xiyadôh de sculk",
  "block.minecraft.sculk_vein": "Bena de sculk",
  "block.minecraft.sea_lantern": "Lintênna marina",
  "block.minecraft.sea_pickle": "Çipote de mâh",
  "block.minecraft.seagrass": "Yerba marina",
  "block.minecraft.set_spawn": "Ça êttableçío er punto de reapariçión",
  "block.minecraft.short_dry_grass": "Yerbah secah i cortah",
  "block.minecraft.short_grass": "Ierba corta",
  "block.minecraft.shroomlight": "Briyongo",
  "block.minecraft.shulker_box": "Caha de shulker",
  "block.minecraft.skeleton_skull": "Calabera de canina",
  "block.minecraft.skeleton_wall_skull": "Calabera de canina en paré",
  "block.minecraft.slime_block": "Bloque de limo",
  "block.minecraft.small_amethyst_bud": "Crîttâh d'ametîtta xico",
  "block.minecraft.small_dripleaf": "Plantaforma xica",
  "block.minecraft.smithing_table": "Meça de herrería",
  "block.minecraft.smoker": "Ahumadôh",
  "block.minecraft.smooth_basalt": "Baçarto pulío",
  "block.minecraft.smooth_quartz": "Bloque de cuarço pulío",
  "block.minecraft.smooth_quartz_slab": "Bardoça de cuarço pulío",
  "block.minecraft.smooth_quartz_stairs": "Êccalerâ de cuarço pulío",
  "block.minecraft.smooth_red_sandstone": "Arbero colorao pulío",
  "block.minecraft.smooth_red_sandstone_slab": "Bardoça d'arbero coloráo pulío",
  "block.minecraft.smooth_red_sandstone_stairs": "Êccalerâ d'arbero colorao pulío",
  "block.minecraft.smooth_sandstone": "Arbero pulío",
  "block.minecraft.smooth_sandstone_slab": "Bardoça d'arbero pulío",
  "block.minecraft.smooth_sandstone_stairs": "Êccalerâ d'arbero pulío",
  "block.minecraft.smooth_stone": "Roca pulía",
  "block.minecraft.smooth_stone_slab": "Bardoça de roca pulía",
  "block.minecraft.sniffer_egg": "Guebo d'olîqqueadôh",
  "block.minecraft.snow": "Niebe",
  "block.minecraft.snow_block": "Bloque de niebe",
  "block.minecraft.soul_campfire": "Candela d'ánimâ",
  "block.minecraft.soul_fire": "Fuego d'ánimâ",
  "block.minecraft.soul_lantern": "Faroliyo d'ánimâ",
  "block.minecraft.soul_sand": "Arena d'ánimâ",
  "block.minecraft.soul_soil": "Tierra d'ánimâ",
  "block.minecraft.soul_torch": "Antorxa d'ánimâ",
  "block.minecraft.soul_wall_torch": "Antorxa d'ánimâ en paré",
  "block.minecraft.spawn.not_valid": "No tienê una cama o áncora de reapariçión cargá, o ç'encuentran ôttruíô",
  "block.minecraft.spawner": "Heneradôh de criaturâ",
  "block.minecraft.spawner.desc1": "Interâttúa con un guebo heneradôh:",
  "block.minecraft.spawner.desc2": "Êttableçe'r tipo de criatura",
  "block.minecraft.sponge": "Êpponha",
  "block.minecraft.spore_blossom": "Flôh d'êpporâ",
  "block.minecraft.spruce_button": "Botón de pinçapo",
  "block.minecraft.spruce_door": "Puerta de pinçapo",
  "block.minecraft.spruce_fence": "Berha de pinçapo",
  "block.minecraft.spruce_fence_gate": "Cançela de pinçapo",
  "block.minecraft.spruce_hanging_sign": "Letrero corgante de pinçapo",
  "block.minecraft.spruce_leaves": "Ohâ de pinçapo",
  "block.minecraft.spruce_log": "Tronco de pinçapo",
  "block.minecraft.spruce_planks": "Tablonê de pinçapo",
  "block.minecraft.spruce_pressure_plate": "Placa de preçión de pinçapo",
  "block.minecraft.spruce_sapling": "Brote de pinçapo",
  "block.minecraft.spruce_shelf": "Êttante de abeto",
  "block.minecraft.spruce_sign": "Letrero de pinçapo",
  "block.minecraft.spruce_slab": "Bardoça de pinçapo",
  "block.minecraft.spruce_stairs": "Êccalerâ de pinçapo",
  "block.minecraft.spruce_trapdoor": "Trampiya de pinçapo",
  "block.minecraft.spruce_wall_hanging_sign": "Letrero corgante de pinçapo en paré",
  "block.minecraft.spruce_wall_sign": "Letrero de pinçapo en paré",
  "block.minecraft.spruce_wood": "Leño de pinçapo",
  "block.minecraft.sticky_piston": "Pîttón pegahoço",
  "block.minecraft.stone": "Roca",
  "block.minecraft.stone_brick_slab": "Bardoça de ladriyô de roca",
  "block.minecraft.stone_brick_stairs": "Êccalerâ de ladriyô de roca",
  "block.minecraft.stone_brick_wall": "Muro de ladriyô de roca",
  "block.minecraft.stone_bricks": "Ladriyô de roca",
  "block.minecraft.stone_button": "Botón de roca",
  "block.minecraft.stone_pressure_plate": "Placa de preçión de roca",
  "block.minecraft.stone_slab": "Bardoça de roca",
  "block.minecraft.stone_stairs": "Êccalerâ de roca",
  "block.minecraft.stonecutter": "Cortapiedrâ",
  "block.minecraft.stripped_acacia_log": "Tronco de mimoça çin corteça",
  "block.minecraft.stripped_acacia_wood": "Leño de mimoça çin corteça",
  "block.minecraft.stripped_bamboo_block": "Bloque de bambú çin corteça",
  "block.minecraft.stripped_birch_log": "Tronco de xopo çin corteça",
  "block.minecraft.stripped_birch_wood": "Leño de xopo çin corteça",
  "block.minecraft.stripped_cherry_log": "Tronco de çereço çin corteça",
  "block.minecraft.stripped_cherry_wood": "Leño de çereço çin corteça",
  "block.minecraft.stripped_crimson_hyphae": "Ifâ carmeçîh çin corteça",
  "block.minecraft.stripped_crimson_stem": "Tayo carmeçí çin corteça",
  "block.minecraft.stripped_dark_oak_log": "Tronco de xaparro çin corteça",
  "block.minecraft.stripped_dark_oak_wood": "Leño de xaparro çin corteça",
  "block.minecraft.stripped_jungle_log": "Tronco de hungla çin corteça",
  "block.minecraft.stripped_jungle_wood": "Leño de hungla çin corteça",
  "block.minecraft.stripped_mangrove_log": "Tronco de mangle çin corteça",
  "block.minecraft.stripped_mangrove_wood": "Leño de mangle çin corteça",
  "block.minecraft.stripped_oak_log": "Tronco de quehigo çin corteça",
  "block.minecraft.stripped_oak_wood": "Leño de quehigo çin corteça",
  "block.minecraft.stripped_pale_oak_log": "Tronco de quehigo pálido çin corteça",
  "block.minecraft.stripped_pale_oak_wood": "Leño de quehigo pálido çin corteça",
  "block.minecraft.stripped_spruce_log": "Tronco de pinçapo çin corteça",
  "block.minecraft.stripped_spruce_wood": "Leño de pinçapo çin corteça",
  "block.minecraft.stripped_warped_hyphae": "Ifâ êttrambóticâ çin corteça",
  "block.minecraft.stripped_warped_stem": "Tayo êttrambótico çin corteça",
  "block.minecraft.structure_block": "Bloque êttrûtturâh",
  "block.minecraft.structure_void": "Baçío êttrûtturâh",
  "block.minecraft.sugar_cane": "Caña d'açúcâ",
  "block.minecraft.sunflower": "Hiraçôh",
  "block.minecraft.suspicious_gravel": "Çaorra çôppexoça",
  "block.minecraft.suspicious_sand": "Arena çôppexoça",
  "block.minecraft.sweet_berry_bush": "Arbûtto de bayâ durçê",
  "block.minecraft.tall_dry_grass": "Yerbah secah i ártah",
  "block.minecraft.tall_grass": "Yerba arta",
  "block.minecraft.tall_seagrass": "Yerba marina arta",
  "block.minecraft.target": "Diana",
  "block.minecraft.terracotta": "Terracota",
  "block.minecraft.test_block": "Bloque-ê pruêbesillah",
  "block.minecraft.test_instance_block": "Blôque d'îttançia",
  "block.minecraft.tinted_glass": "Crîttâh êccureçío",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "Lâh êpploçionê de TNT êttán deçactibâh",
  "block.minecraft.torch": "Antorxa",
  "block.minecraft.torchflower": "Plantorxa",
  "block.minecraft.torchflower_crop": "Curtibo de plantorxa",
  "block.minecraft.trapped_chest": "Baûh trampa",
  "block.minecraft.trial_spawner": "Heneradôh de criaturâ de deçafío",
  "block.minecraft.tripwire": "Cordêh trampa",
  "block.minecraft.tripwire_hook": "Ganxo de cordêh trampa",
  "block.minecraft.tube_coral": "Corâh de tubo",
  "block.minecraft.tube_coral_block": "Bloque de corâh de tubo",
  "block.minecraft.tube_coral_fan": "Gorgonia de tubo",
  "block.minecraft.tube_coral_wall_fan": "Gorgonia de tubo en paré",
  "block.minecraft.tuff": "Tôcca",
  "block.minecraft.tuff_brick_slab": "Loça de ladriyô de toba",
  "block.minecraft.tuff_brick_stairs": "Êccalerâ de ladriyô de toba",
  "block.minecraft.tuff_brick_wall": "Muro de ladriyô de toba",
  "block.minecraft.tuff_bricks": "Ladriyô de toba",
  "block.minecraft.tuff_slab": "Loça de toba",
  "block.minecraft.tuff_stairs": "Êccalerâ de toba",
  "block.minecraft.tuff_wall": "Muro de toba",
  "block.minecraft.turtle_egg": "Guebo de tortuga",
  "block.minecraft.twisting_vines": "Enreaera retorçía",
  "block.minecraft.twisting_vines_plant": "Planta d'enreaera retorçía",
  "block.minecraft.vault": "Arcón",
  "block.minecraft.verdant_froglight": "Linterana berdoça",
  "block.minecraft.vine": "Enreaera",
  "block.minecraft.void_air": "Aire der baçío",
  "block.minecraft.wall_torch": "Antorxa en paré",
  "block.minecraft.warped_button": "Botón êttrambótico",
  "block.minecraft.warped_door": "Puerta êttrambótica",
  "block.minecraft.warped_fence": "Berha êttrambótica",
  "block.minecraft.warped_fence_gate": "Cançela êttrambótica",
  "block.minecraft.warped_fungus": "Hongo êttrambótico",
  "block.minecraft.warped_hanging_sign": "Letrero corgante êttrambótico",
  "block.minecraft.warped_hyphae": "Ifâ êttrambóticâ",
  "block.minecraft.warped_nylium": "Niçelio êttrambótico",
  "block.minecraft.warped_planks": "Tablonê êttrambóticô",
  "block.minecraft.warped_pressure_plate": "Placa de preçión êttrambótica",
  "block.minecraft.warped_roots": "Raíçê êttrambóticâ",
  "block.minecraft.warped_shelf": "Êttante dîttorçionao",
  "block.minecraft.warped_sign": "Letrero êttrambótico",
  "block.minecraft.warped_slab": "Bardoça êttrambótica",
  "block.minecraft.warped_stairs": "Êccalerâ êttrambóticâ",
  "block.minecraft.warped_stem": "Tayo êttrambótico",
  "block.minecraft.warped_trapdoor": "Trampiya êttrambótica",
  "block.minecraft.warped_wall_hanging_sign": "Letrero corgante êttrambótico en paré",
  "block.minecraft.warped_wall_sign": "Letrero êttrambótico en paré",
  "block.minecraft.warped_wart_block": "Bloque de berrugâ êttrambóticâ",
  "block.minecraft.water": "Agua",
  "block.minecraft.water_cauldron": "Cardero d'agua",
  "block.minecraft.waxed_chiseled_copper": "Cobre çinçelao ençerao",
  "block.minecraft.waxed_copper_bars": "Barrotê de cobre ençerao",
  "block.minecraft.waxed_copper_block": "Bloque de cobre ençerao",
  "block.minecraft.waxed_copper_bulb": "Lámpa de cobre ençerao",
  "block.minecraft.waxed_copper_chain": "Cadena de cobre ençerao",
  "block.minecraft.waxed_copper_chest": "Cofre de cobre ençerao",
  "block.minecraft.waxed_copper_door": "Puerta de cobre ençerao",
  "block.minecraft.waxed_copper_golem_statue": "Êttatua de gólem de cobre ençerao",
  "block.minecraft.waxed_copper_grate": "Rehiya de cobre ençerao",
  "block.minecraft.waxed_copper_lantern": "Farôh de cobre ençerao",
  "block.minecraft.waxed_copper_trapdoor": "Trampiya de cobre ençerao",
  "block.minecraft.waxed_cut_copper": "Cobre cortao ençerao",
  "block.minecraft.waxed_cut_copper_slab": "Bardoça de cobre cortao ençerao",
  "block.minecraft.waxed_cut_copper_stairs": "Êccalerâ de cobre cortao ençerao",
  "block.minecraft.waxed_exposed_chiseled_copper": "Cobre çinçelao êppuêtto ençerao",
  "block.minecraft.waxed_exposed_copper": "Cobre êppuêtto ençerao",
  "block.minecraft.waxed_exposed_copper_bars": "Barrotê de cobre êppuêtto ençerao",
  "block.minecraft.waxed_exposed_copper_bulb": "Lámpa de cobre êppuêtto ençerao",
  "block.minecraft.waxed_exposed_copper_chain": "Cadena de cobre êppuêtto ençerao",
  "block.minecraft.waxed_exposed_copper_chest": "Cofre de cobre êppuêtto ençera",
  "block.minecraft.waxed_exposed_copper_door": "Puerta de cobre êppuêtto ençerao",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Êttatua de gólem de cobre êppuêtto ençerao",
  "block.minecraft.waxed_exposed_copper_grate": "Rehiya de cobre êppuêtto ençerao",
  "block.minecraft.waxed_exposed_copper_lantern": "Farôh de cobre êppuêtto ençerao",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Trampiya de cobre êppuêtto ençerao",
  "block.minecraft.waxed_exposed_cut_copper": "Cobre cortao êppuêtto ençerao",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Bardoça de cobre cortao êppuêtto ençerao",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Êccalerâ de cobre cortao êppuêtto ençerao",
  "block.minecraft.waxed_exposed_lightning_rod": "Pararrayô êppuêtto ençerao",
  "block.minecraft.waxed_lightning_rod": "Pararrayô ençerao",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Cobre çinçelao ôççidao ençerao",
  "block.minecraft.waxed_oxidized_copper": "Cobre ôççidao ençerao",
  "block.minecraft.waxed_oxidized_copper_bars": "Barrotê de cobre ôççidao ençerao",
  "block.minecraft.waxed_oxidized_copper_bulb": "Lámpa de cobre ôççidao ençerao",
  "block.minecraft.waxed_oxidized_copper_chain": "Cadena de cobre ôççidao ençerao",
  "block.minecraft.waxed_oxidized_copper_chest": "Cofre de cobre ôççidao ençerao",
  "block.minecraft.waxed_oxidized_copper_door": "Puerta de cobre ôççidao ençerao",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Êttatua de gólem de cobre ôççidao ençerao",
  "block.minecraft.waxed_oxidized_copper_grate": "Rehiya de cobre ôççidao ençerao",
  "block.minecraft.waxed_oxidized_copper_lantern": "Farôh de cobre ôççidao ençerao",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Trampiya de cobre ôççidao ençerao",
  "block.minecraft.waxed_oxidized_cut_copper": "Cobre cortao ôççidao ençerao",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Bardoça de cobre cortao ôççidao ençerao",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Êccalerâ de cobre cortao ôççidao ençerao",
  "block.minecraft.waxed_oxidized_lightning_rod": "Pararrayô ôççidao ençerao",
  "block.minecraft.waxed_weathered_chiseled_copper": "Cobre çinçelao degradao ençerao",
  "block.minecraft.waxed_weathered_copper": "Cobre corroío ençerao",
  "block.minecraft.waxed_weathered_copper_bars": "Barrotê de cobre degradao ençerao",
  "block.minecraft.waxed_weathered_copper_bulb": "Lámpa de cobre degradao ençerao",
  "block.minecraft.waxed_weathered_copper_chain": "Cadena de cobre degradao ençerao",
  "block.minecraft.waxed_weathered_copper_chest": "Cofre de cobre degradao ençerao",
  "block.minecraft.waxed_weathered_copper_door": "Puerta de cobre degradao ençerao",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Êttatua de gólem de cobre degradao ençerao",
  "block.minecraft.waxed_weathered_copper_grate": "Rehiya de cobre degradao ençerao",
  "block.minecraft.waxed_weathered_copper_lantern": "Farôh de cobre degradao ençerao",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Trampiya de cobre degradao ençerao",
  "block.minecraft.waxed_weathered_cut_copper": "Cobre cortao corroío ençerao",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Bardoça de cobre cortao corroío ençerao",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Êccalerâ de cobre cortao corroío ençerao",
  "block.minecraft.waxed_weathered_lightning_rod": "Pararrayô degradao ençerao",
  "block.minecraft.weathered_chiseled_copper": "Cobre çinçelao degradao",
  "block.minecraft.weathered_copper": "Cobre corroío",
  "block.minecraft.weathered_copper_bars": "Barrotê de cobre degradao",
  "block.minecraft.weathered_copper_bulb": "Lámpa de cobre degradao",
  "block.minecraft.weathered_copper_chain": "Cadena de cobre degradao",
  "block.minecraft.weathered_copper_chest": "Cofre de cobre degradao",
  "block.minecraft.weathered_copper_door": "Puerta de cobre degradao",
  "block.minecraft.weathered_copper_golem_statue": "Êttatua de gólem de cobre degradao",
  "block.minecraft.weathered_copper_grate": "Rehiya de cobre degradao",
  "block.minecraft.weathered_copper_lantern": "Farôh de cobre degradao",
  "block.minecraft.weathered_copper_trapdoor": "Trampiya de cobre degradao",
  "block.minecraft.weathered_cut_copper": "Cobre cortao ôççidao",
  "block.minecraft.weathered_cut_copper_slab": "Bardoça de cobre cortao ôççidao",
  "block.minecraft.weathered_cut_copper_stairs": "Êccalerâ de cobre cortao ôççidao",
  "block.minecraft.weathered_lightning_rod": "Pararrayô degradao",
  "block.minecraft.weeping_vines": "Enreaera çoyoçante",
  "block.minecraft.weeping_vines_plant": "Planta d'enreaera çoyoçante",
  "block.minecraft.wet_sponge": "Êpponha mohá",
  "block.minecraft.wheat": "Curtibo de trigo",
  "block.minecraft.white_banner": "Êttandarte blanco",
  "block.minecraft.white_bed": "Cama blanca",
  "block.minecraft.white_candle": "Çirio blanco",
  "block.minecraft.white_candle_cake": "Tarta con çirio blanco",
  "block.minecraft.white_carpet": "Arfombra blanca",
  "block.minecraft.white_concrete": "Hormigón blanco",
  "block.minecraft.white_concrete_powder": "Çemento blanco",
  "block.minecraft.white_glazed_terracotta": "Açuleho blanco",
  "block.minecraft.white_shulker_box": "Caha de shulker blanca",
  "block.minecraft.white_stained_glass": "Crîttâh tintao de blanco",
  "block.minecraft.white_stained_glass_pane": "Panêh de crîttâh tintao de blanco",
  "block.minecraft.white_terracotta": "Terracota blanca",
  "block.minecraft.white_tulip": "Tulipán blanco",
  "block.minecraft.white_wool": "Lana blanca",
  "block.minecraft.wildflowers": "Florê çirbêttrê",
  "block.minecraft.wither_rose": "Roça de Wither",
  "block.minecraft.wither_skeleton_skull": "Calabera de canina der Wither",
  "block.minecraft.wither_skeleton_wall_skull": "Calabera de canina der Wither en paré",
  "block.minecraft.yellow_banner": "Êttandarte amariyo",
  "block.minecraft.yellow_bed": "Cama amariya",
  "block.minecraft.yellow_candle": "Çirio amariyo",
  "block.minecraft.yellow_candle_cake": "Tarta con çirio amariyo",
  "block.minecraft.yellow_carpet": "Arfombra amariya",
  "block.minecraft.yellow_concrete": "Hormigón amariyo",
  "block.minecraft.yellow_concrete_powder": "Çemento amariyo",
  "block.minecraft.yellow_glazed_terracotta": "Açuleho amariyo",
  "block.minecraft.yellow_shulker_box": "Caha de shulker amariya",
  "block.minecraft.yellow_stained_glass": "Crîttâh tintao d'amariyo",
  "block.minecraft.yellow_stained_glass_pane": "Panêh de crîttâh tintao d'amariyo",
  "block.minecraft.yellow_terracotta": "Terracota amariya",
  "block.minecraft.yellow_wool": "Lana amariya",
  "block.minecraft.zombie_head": "Cabeça de çombi",
  "block.minecraft.zombie_wall_head": "Cabeça de çombi en paré",
  "item.minecraft.acacia_boat": "Barca de mimoça",
  "item.minecraft.acacia_chest_boat": "Barca de mimoça con baûh",
  "item.minecraft.allay_spawn_egg": "Guebo heneradôh d'allay",
  "item.minecraft.amethyst_shard": "Frâmmento d'ametîtta",
  "item.minecraft.angler_pottery_shard": "Frâmmento de çerámica de pêccadôh",
  "item.minecraft.angler_pottery_sherd": "Frâmmento de çerámica de caña de pêccâh",
  "item.minecraft.apple": "Pero",
  "item.minecraft.archer_pottery_shard": "Frâmmento de çerámica d'arquero",
  "item.minecraft.archer_pottery_sherd": "Frâmmento de çerámica de arco",
  "item.minecraft.armadillo_scute": "Êccama d'armaíyo",
  "item.minecraft.armadillo_spawn_egg": "Guebo heneradôh d'armadiyo",
  "item.minecraft.armor_stand": "Maniquí",
  "item.minecraft.arms_up_pottery_shard": "Frâmmento de çerámica de monigote",
  "item.minecraft.arms_up_pottery_sherd": "Frâmmento de çerámica dermonigote",
  "item.minecraft.arrow": "Flexa",
  "item.minecraft.axolotl_bucket": "Barde con aholote",
  "item.minecraft.axolotl_spawn_egg": "Guebo heneradôh d'aholote",
  "item.minecraft.baked_potato": "Papa açá",
  "item.minecraft.bamboo_chest_raft": "Armadía de bambú con baûh",
  "item.minecraft.bamboo_raft": "Armadía de bambú",
  "item.minecraft.bat_spawn_egg": "Guebo heneradôh de murçiégalo",
  "item.minecraft.bee_spawn_egg": "Guebo heneradôh d'abeha",
  "item.minecraft.beef": "Bîtté crúo",
  "item.minecraft.beetroot": "Remolaxa",
  "item.minecraft.beetroot_seeds": "Çemiyâ de remolaxa",
  "item.minecraft.beetroot_soup": "Çopa de remolaxa",
  "item.minecraft.birch_boat": "Barca de xopo",
  "item.minecraft.birch_chest_boat": "Barca de xopo con baûh",
  "item.minecraft.black_bundle": "Çaco êccuro",
  "item.minecraft.black_dye": "Tinte êccuro",
  "item.minecraft.black_harness": "Arnêh",
  "item.minecraft.blade_pottery_shard": "Frâmmento de çerámica de êppá",
  "item.minecraft.blade_pottery_sherd": "Frâmmento de zerámica de êppá",
  "item.minecraft.blaze_powder": "Porbo de blaze",
  "item.minecraft.blaze_rod": "Bara de blaze",
  "item.minecraft.blaze_spawn_egg": "Guebo heneradôh de blaze",
  "item.minecraft.blue_bundle": "Çaco açûh",
  "item.minecraft.blue_dye": "Tinte açûh",
  "item.minecraft.blue_egg": "Guebo açûh",
  "item.minecraft.blue_harness": "Arnêh açûh",
  "item.minecraft.bogged_spawn_egg": "Henerâh çiénago",
  "item.minecraft.bolt_armor_trim_smithing_template": "Morde d'errería",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Diçeño de remaxê",
  "item.minecraft.bone": "Gueço",
  "item.minecraft.bone_meal": "Harina de gueço",
  "item.minecraft.book": "Libro",
  "item.minecraft.bordure_indented_banner_pattern": "Êttampao de bordura dentá",
  "item.minecraft.bow": "Arco",
  "item.minecraft.bowl": "Taçón",
  "item.minecraft.bread": "Pan",
  "item.minecraft.breeze_rod": "Bara de breeze",
  "item.minecraft.breeze_spawn_egg": "Henerâh breeze",
  "item.minecraft.brewer_pottery_shard": "Frâmmento de çerámica de poçión",
  "item.minecraft.brewer_pottery_sherd": "Frâmmento de çerámica de pozión",
  "item.minecraft.brewing_stand": "Alambique",
  "item.minecraft.brick": "Ladriyo",
  "item.minecraft.brown_bundle": "Çaco marrón",
  "item.minecraft.brown_dye": "Tinte marrón",
  "item.minecraft.brown_egg": "Guebo marrôh",
  "item.minecraft.brown_harness": "Arnêh marrón",
  "item.minecraft.brush": "Broxa",
  "item.minecraft.bucket": "Barde",
  "item.minecraft.bundle": "Talega",
  "item.minecraft.bundle.empty": "Baçía",
  "item.minecraft.bundle.empty.description": "Pué contenêh una pila mîtta d'ôhhetô",
  "item.minecraft.bundle.full": "Yena",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Frâmmento de çerámica de yamâ",
  "item.minecraft.burn_pottery_sherd": "Frâmmento de çerámica de fuego",
  "item.minecraft.camel_husk_spawn_egg": "Henerâh cameyo diçecao",
  "item.minecraft.camel_spawn_egg": "Guebo heneradôh de cameyo",
  "item.minecraft.carrot": "Çanahoria",
  "item.minecraft.carrot_on_a_stick": "Çanahoria n'una caña",
  "item.minecraft.cat_spawn_egg": "Guebo heneradôh de gato",
  "item.minecraft.cauldron": "Cardero",
  "item.minecraft.cave_spider_spawn_egg": "Guebo heneradôh d'araña de cueba",
  "item.minecraft.chainmail_boots": "Botâ de cota de maya",
  "item.minecraft.chainmail_chestplate": "Pexera de cota de maya",
  "item.minecraft.chainmail_helmet": "Câcco de cota de maya",
  "item.minecraft.chainmail_leggings": "Grebâ de cota de maya",
  "item.minecraft.charcoal": "Carbón behetâh",
  "item.minecraft.cherry_boat": "Barca de çereço",
  "item.minecraft.cherry_chest_boat": "Barca de çereço con baûh",
  "item.minecraft.chest_minecart": "Bagoneta con baûh",
  "item.minecraft.chicken": "Poyo crúo",
  "item.minecraft.chicken_spawn_egg": "Guebo heneradôh de gayina",
  "item.minecraft.chorus_fruit": "Fruta de chorus",
  "item.minecraft.clay_ball": "Bola d'arçiya",
  "item.minecraft.clock": "Relôh",
  "item.minecraft.coal": "Carbón",
  "item.minecraft.coast_armor_trim_smithing_template": "Morde d'errería",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Diçeño d'armaúra côttera",
  "item.minecraft.cocoa_beans": "Çemiyâ de cacao",
  "item.minecraft.cod": "Abadeho crúo",
  "item.minecraft.cod_bucket": "Barde con abadeho",
  "item.minecraft.cod_spawn_egg": "Guebo heneradôh d'abadeho",
  "item.minecraft.command_block_minecart": "Bagoneta con bloque de comandô",
  "item.minecraft.compass": "Brúhula",
  "item.minecraft.cooked_beef": "Bîtté açao",
  "item.minecraft.cooked_chicken": "Poyo açao",
  "item.minecraft.cooked_cod": "Abadeho açao",
  "item.minecraft.cooked_mutton": "Cordero açao",
  "item.minecraft.cooked_porkchop": "Xuleta açá",
  "item.minecraft.cooked_rabbit": "Coneho açao",
  "item.minecraft.cooked_salmon": "Çarmón açao",
  "item.minecraft.cookie": "Gayeta",
  "item.minecraft.copper_axe": "Axa de cobre",
  "item.minecraft.copper_boots": "Botâ de cobre",
  "item.minecraft.copper_chestplate": "Peto de cobre",
  "item.minecraft.copper_golem_spawn_egg": "Henerâh gólem de cobre",
  "item.minecraft.copper_helmet": "Câcco de cobre",
  "item.minecraft.copper_hoe": "Açá de cobre",
  "item.minecraft.copper_horse_armor": "Armaúra de cobre pa haca",
  "item.minecraft.copper_ingot": "Lingote de cobre",
  "item.minecraft.copper_leggings": "Grebâ de cobre",
  "item.minecraft.copper_nautilus_armor": "Armaúra de cobre pa nautilo",
  "item.minecraft.copper_nugget": "Pepita de cobre",
  "item.minecraft.copper_pickaxe": "Pico de cobre",
  "item.minecraft.copper_shovel": "Pala de cobre",
  "item.minecraft.copper_spear": "Lança de cobre",
  "item.minecraft.copper_sword": "Êppá de cobre",
  "item.minecraft.cow_spawn_egg": "Guebo heneradôh de baca",
  "item.minecraft.creaking_spawn_egg": "Henerâh cruhidôh",
  "item.minecraft.creeper_banner_pattern": "Diçeño d'êttandarte",
  "item.minecraft.creeper_banner_pattern.desc": "Êttampao de creeper",
  "item.minecraft.creeper_banner_pattern.new": "Etampâo de creeper",
  "item.minecraft.creeper_spawn_egg": "Guebo heneradôh de creeper",
  "item.minecraft.crossbow": "Bayêtta",
  "item.minecraft.crossbow.projectile": "Proyêttîh:",
  "item.minecraft.crossbow.projectile.multiple": "Proyettîh: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Proyettîh: %s",
  "item.minecraft.cyan_bundle": "Çaco çiân",
  "item.minecraft.cyan_dye": "Tinte çian",
  "item.minecraft.cyan_harness": "Arnêh çian",
  "item.minecraft.danger_pottery_shard": "Frâmmento de çerámica de peligro",
  "item.minecraft.danger_pottery_sherd": "Frâmmento de çerámica de creeper",
  "item.minecraft.dark_oak_boat": "Barca de xaparro",
  "item.minecraft.dark_oak_chest_boat": "Barca de xaparro con baûh",
  "item.minecraft.debug_stick": "Tarama de depuraçión",
  "item.minecraft.debug_stick.empty": "%s no tié propiedadê",
  "item.minecraft.debug_stick.select": "çelêççionao \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" a cambiao a %s",
  "item.minecraft.diamond": "Diamante",
  "item.minecraft.diamond_axe": "Haxa de diamante",
  "item.minecraft.diamond_boots": "Botâ de diamante",
  "item.minecraft.diamond_chestplate": "Pexera de diamante",
  "item.minecraft.diamond_helmet": "Câcco de diamante",
  "item.minecraft.diamond_hoe": "Çoleta de diamante",
  "item.minecraft.diamond_horse_armor": "Armaúra de diamante pa haca",
  "item.minecraft.diamond_leggings": "Grebâ de diamante",
  "item.minecraft.diamond_nautilus_armor": "Armaúra de diamante pa nautilo",
  "item.minecraft.diamond_pickaxe": "Êppioxa de diamante",
  "item.minecraft.diamond_shovel": "Pala de diamante",
  "item.minecraft.diamond_spear": "Lança de diamante",
  "item.minecraft.diamond_sword": "Êppá de diamante",
  "item.minecraft.disc_fragment_5": "Frâmmento de dîcco",
  "item.minecraft.disc_fragment_5.desc": "Dîcco de múçica - 5",
  "item.minecraft.dolphin_spawn_egg": "Guebo heneradôh de derfín",
  "item.minecraft.donkey_spawn_egg": "Guebo heneradôh de burro",
  "item.minecraft.dragon_breath": "Aliento de dragón",
  "item.minecraft.dried_kelp": "Argâ çecâ",
  "item.minecraft.drowned_spawn_egg": "Guebo heneradôh d'ahogao",
  "item.minecraft.dune_armor_trim_smithing_template": "Morde d'errería",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Diçeño d'armaúra de lâh dunâh",
  "item.minecraft.echo_shard": "Frâmmento d'eco",
  "item.minecraft.egg": "Guebo",
  "item.minecraft.elder_guardian_spawn_egg": "Guebo heneradôh de guardián ançiano",
  "item.minecraft.elytra": "Elytra",
  "item.minecraft.emerald": "Êmmerarda",
  "item.minecraft.enchanted_book": "Libro encantao",
  "item.minecraft.enchanted_golden_apple": "Pero d'oro encantao",
  "item.minecraft.end_crystal": "Crîttâh del End",
  "item.minecraft.ender_dragon_spawn_egg": "Guebo heneradôh de dragón d'Ender",
  "item.minecraft.ender_eye": "Oho d'Ender",
  "item.minecraft.ender_pearl": "Pêl-la d'Ender",
  "item.minecraft.enderman_spawn_egg": "Guebo heneradôh d'Enderman",
  "item.minecraft.endermite_spawn_egg": "Guebo heneradôh d'Endermite",
  "item.minecraft.evoker_spawn_egg": "Guebo heneradôh d'imbocadôh",
  "item.minecraft.experience_bottle": "Frâcco con êpperiençia",
  "item.minecraft.explorer_pottery_shard": "Frâmmento de çerámica de mapa",
  "item.minecraft.explorer_pottery_sherd": "Frâmmento de çerámica de mapa",
  "item.minecraft.eye_armor_trim_smithing_template": "Morde d'errería",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Diçeño d'armaúra d'ohôs",
  "item.minecraft.feather": "Pluma",
  "item.minecraft.fermented_spider_eye": "Oho d'araña fermentao",
  "item.minecraft.field_masoned_banner_pattern": "Etampâo d'eppirâh",
  "item.minecraft.filled_map": "Mapa",
  "item.minecraft.fire_charge": "Carga ínnea",
  "item.minecraft.firework_rocket": "Fuegô artifiçialê",
  "item.minecraft.firework_rocket.flight": "Duraçión der buelo:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Êttreya de fuegô artifiçialê",
  "item.minecraft.firework_star.black": "Êccura",
  "item.minecraft.firework_star.blue": "Açûh",
  "item.minecraft.firework_star.brown": "Marrón",
  "item.minecraft.firework_star.custom_color": "Perçonaliçao",
  "item.minecraft.firework_star.cyan": "Çian",
  "item.minecraft.firework_star.fade_to": "Çe buerbe",
  "item.minecraft.firework_star.flicker": "Çenteyeo",
  "item.minecraft.firework_star.gray": "Grîh",
  "item.minecraft.firework_star.green": "Berde",
  "item.minecraft.firework_star.light_blue": "Açûh clara",
  "item.minecraft.firework_star.light_gray": "Grîh clara",
  "item.minecraft.firework_star.lime": "Lima",
  "item.minecraft.firework_star.magenta": "Mahenta",
  "item.minecraft.firework_star.orange": "Naranha",
  "item.minecraft.firework_star.pink": "Roça",
  "item.minecraft.firework_star.purple": "Morá",
  "item.minecraft.firework_star.red": "Colorá",
  "item.minecraft.firework_star.shape": "Forma dêcconoçía",
  "item.minecraft.firework_star.shape.burst": "Êpplotío",
  "item.minecraft.firework_star.shape.creeper": "Con forma de creeper",
  "item.minecraft.firework_star.shape.large_ball": "Bola grande",
  "item.minecraft.firework_star.shape.small_ball": "Bola xica",
  "item.minecraft.firework_star.shape.star": "Con forma d'êttreya",
  "item.minecraft.firework_star.trail": "Râttro",
  "item.minecraft.firework_star.white": "Blanca",
  "item.minecraft.firework_star.yellow": "Amariya",
  "item.minecraft.fishing_rod": "Caña de pêccâh",
  "item.minecraft.flint": "Pedênnâh",
  "item.minecraft.flint_and_steel": "Ençendedôh",
  "item.minecraft.flow_armor_trim_smithing_template": "Morde d'errería",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Diçeño d'armaúra d'eppirâh",
  "item.minecraft.flow_banner_pattern": "Diseño d'êttandarte",
  "item.minecraft.flow_banner_pattern.desc": "Êttampao d'êppirâh",
  "item.minecraft.flow_banner_pattern.new": "Etampâo d'eppirâh",
  "item.minecraft.flow_pottery_sherd": "Frâmmento de çerámica d'êppirâh",
  "item.minecraft.flower_banner_pattern": "Patrón d'êttandarte",
  "item.minecraft.flower_banner_pattern.desc": "Êttampao de flôh",
  "item.minecraft.flower_banner_pattern.new": "Etampâo de flôreh",
  "item.minecraft.flower_pot": "Tiêtto",
  "item.minecraft.fox_spawn_egg": "Guebo heneradôh de çorro",
  "item.minecraft.friend_pottery_shard": "Frâmmento de çerámica de amîttá",
  "item.minecraft.friend_pottery_sherd": "Frâmmento de çerámica de amîttá",
  "item.minecraft.frog_spawn_egg": "Guebo heneradôh de rana",
  "item.minecraft.furnace_minecart": "Bagoneta con hônno",
  "item.minecraft.ghast_spawn_egg": "Guebo heneradôh de ghast",
  "item.minecraft.ghast_tear": "Lágrima de ghast",
  "item.minecraft.glass_bottle": "Frâcco de crîttâh",
  "item.minecraft.glistering_melon_slice": "Tahá d'açendía briyante",
  "item.minecraft.globe_banner_pattern": "Patrón d'êttandarte",
  "item.minecraft.globe_banner_pattern.desc": "Êttampao de planeta",
  "item.minecraft.globe_banner_pattern.new": "Etampâo de planêta",
  "item.minecraft.glow_berries": "Bayâ briyantê",
  "item.minecraft.glow_ink_sac": "Çaco de tinta briyante",
  "item.minecraft.glow_item_frame": "Marco briyante",
  "item.minecraft.glow_squid_spawn_egg": "Guebo heneradôh de xoco briyante",
  "item.minecraft.glowstone_dust": "Porbo de roca briyante",
  "item.minecraft.goat_horn": "Cuênno cabra",
  "item.minecraft.goat_spawn_egg": "Guebo heneradôh de cabra",
  "item.minecraft.gold_ingot": "Lingote d'oro",
  "item.minecraft.gold_nugget": "Pepita d'oro",
  "item.minecraft.golden_apple": "Pero d'oro",
  "item.minecraft.golden_axe": "Haxa d'oro",
  "item.minecraft.golden_boots": "Botâ d'oro",
  "item.minecraft.golden_carrot": "Çanahoria dorá",
  "item.minecraft.golden_chestplate": "Pexera d'oro",
  "item.minecraft.golden_helmet": "Câcco d'oro",
  "item.minecraft.golden_hoe": "Çoleta d'oro",
  "item.minecraft.golden_horse_armor": "Armaúra d'oro pa haca",
  "item.minecraft.golden_leggings": "Grebâ d'oro",
  "item.minecraft.golden_nautilus_armor": "Armaúra d'oro pa nautilo",
  "item.minecraft.golden_pickaxe": "Êppioxa d'oro",
  "item.minecraft.golden_shovel": "Pala d'oro",
  "item.minecraft.golden_spear": "Lança de oro",
  "item.minecraft.golden_sword": "Êppá d'oro",
  "item.minecraft.gray_bundle": "Çaco grîh",
  "item.minecraft.gray_dye": "Tinte grîh",
  "item.minecraft.gray_harness": "Arnêh grîh",
  "item.minecraft.green_bundle": "Çaco berde",
  "item.minecraft.green_dye": "Tinte berde",
  "item.minecraft.green_harness": "Arnêh berde",
  "item.minecraft.guardian_spawn_egg": "Guebo heneradôh de guardián",
  "item.minecraft.gunpowder": "Pórbora",
  "item.minecraft.guster_banner_pattern": "Diseño d'êttandarte",
  "item.minecraft.guster_banner_pattern.desc": "Buster",
  "item.minecraft.guster_banner_pattern.new": "Etampâo de brîça",
  "item.minecraft.guster_pottery_sherd": "Fragmento de cerâmica buster ",
  "item.minecraft.happy_ghast_spawn_egg": "Henerâh ghast felîh",
  "item.minecraft.harness": "Arnêh",
  "item.minecraft.heart_of_the_sea": "Coraçón der mâh",
  "item.minecraft.heart_pottery_shard": "Frâmmento de çerámica de coraçón",
  "item.minecraft.heart_pottery_sherd": "Frâmmento de çerámica de corazón",
  "item.minecraft.heartbreak_pottery_shard": "Frâmmento de çerámica de coraçón roto",
  "item.minecraft.heartbreak_pottery_sherd": "Frâmmento de çerámica de corazón roto",
  "item.minecraft.hoglin_spawn_egg": "Guebo heneradôh de hoglin",
  "item.minecraft.honey_bottle": "Frâcco con miêh",
  "item.minecraft.honeycomb": "Panâh",
  "item.minecraft.hopper_minecart": "Bagoneta con torba",
  "item.minecraft.horse_spawn_egg": "Guebo heneradôh de haca",
  "item.minecraft.host_armor_trim_smithing_template": "Morde d'errería",
  "item.minecraft.host_armor_trim_smithing_template.new": "Diçêño d'amadúrah d'anfitrióh",
  "item.minecraft.howl_pottery_shard": "Frâmmento de çerámica de lobo",
  "item.minecraft.howl_pottery_sherd": "Frâmmento de çerámica de lobo",
  "item.minecraft.husk_spawn_egg": "Guebo heneradôh de momia",
  "item.minecraft.ink_sac": "Çaco de tinta",
  "item.minecraft.iron_axe": "Haxa de yerro",
  "item.minecraft.iron_boots": "Botâ de yerro",
  "item.minecraft.iron_chestplate": "Pexera de yerro",
  "item.minecraft.iron_golem_spawn_egg": "Guebo heneradôh de gólem de yerro",
  "item.minecraft.iron_helmet": "Câcco de yerro",
  "item.minecraft.iron_hoe": "Çoleta de yerro",
  "item.minecraft.iron_horse_armor": "Armaúra de yerro pa haca",
  "item.minecraft.iron_ingot": "Lingote de yerro",
  "item.minecraft.iron_leggings": "Grebâ de yerro",
  "item.minecraft.iron_nautilus_armor": "Armaúra de yerro pa nautilo",
  "item.minecraft.iron_nugget": "Pepita de yerro",
  "item.minecraft.iron_pickaxe": "Êppioxa de yerro",
  "item.minecraft.iron_shovel": "Pala de yerro",
  "item.minecraft.iron_spear": "Lança de yerro",
  "item.minecraft.iron_sword": "Êppá de yerro",
  "item.minecraft.item_frame": "Marco",
  "item.minecraft.jungle_boat": "Barca de hungla",
  "item.minecraft.jungle_chest_boat": "Barca de hungla con baûh",
  "item.minecraft.knowledge_book": "Ençiclopedia",
  "item.minecraft.lapis_lazuli": "Lapîl-láçuli",
  "item.minecraft.lava_bucket": "Barde de laba",
  "item.minecraft.lead": "Rienda",
  "item.minecraft.leather": "Cuero",
  "item.minecraft.leather_boots": "Botâ de cuero",
  "item.minecraft.leather_chestplate": "Túnica de cuero",
  "item.minecraft.leather_helmet": "Gorro de cuero",
  "item.minecraft.leather_horse_armor": "Armaúra de cuero pa haca",
  "item.minecraft.leather_leggings": "Pênnerâ de cuero",
  "item.minecraft.light_blue_bundle": "Çaco açûh claro",
  "item.minecraft.light_blue_dye": "Tinte açûh claro",
  "item.minecraft.light_blue_harness": "Arnêh açûh claro",
  "item.minecraft.light_gray_bundle": "Çaco grîh clâo",
  "item.minecraft.light_gray_dye": "Tinte grîh claro",
  "item.minecraft.light_gray_harness": "Arnêh grîh claro",
  "item.minecraft.lime_bundle": "Çaco bêrde clâo",
  "item.minecraft.lime_dye": "Tinte lima",
  "item.minecraft.lime_harness": "Arnêh berde lima",
  "item.minecraft.lingering_potion": "Brebahe perçîttente",
  "item.minecraft.lingering_potion.effect.awkward": "Brebahe raro perçîttente",
  "item.minecraft.lingering_potion.effect.empty": "Brebahe perçîttente no crâtteablê",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Brebahe perçîttente de cuerpo înnífugo",
  "item.minecraft.lingering_potion.effect.harming": "Brebahe perçîttente de daño",
  "item.minecraft.lingering_potion.effect.healing": "Brebahe perçîttente de curaçión",
  "item.minecraft.lingering_potion.effect.infested": "Poção resistente de infestação",
  "item.minecraft.lingering_potion.effect.invisibility": "Brebahe perçîttente de imbiçibilidá",
  "item.minecraft.lingering_potion.effect.leaping": "Brebahe perçîttente de çarto",
  "item.minecraft.lingering_potion.effect.levitation": "Brebahe perçîttente de lebitaçión",
  "item.minecraft.lingering_potion.effect.luck": "Brebahe perçîttente de potra",
  "item.minecraft.lingering_potion.effect.mundane": "Brebahe mundano perçîttente",
  "item.minecraft.lingering_potion.effect.night_vision": "Brebahe perçîttente de biçión nôttûnna",
  "item.minecraft.lingering_potion.effect.oozing": "Brebahe perçîttente de mucoçidá",
  "item.minecraft.lingering_potion.effect.poison": "Brebahe perçîttente de beneno",
  "item.minecraft.lingering_potion.effect.regeneration": "Brebahe perçîttente de reheneraçión",
  "item.minecraft.lingering_potion.effect.slow_falling": "Brebahe perçîttente de caída lenta",
  "item.minecraft.lingering_potion.effect.slowness": "Brebahe perçîttente de lentitûh",
  "item.minecraft.lingering_potion.effect.strength": "Brebahe perçîttente de fuerça",
  "item.minecraft.lingering_potion.effect.swiftness": "Brebahe perçîttente de rapidêh",
  "item.minecraft.lingering_potion.effect.thick": "Brebahe denço perçîttente",
  "item.minecraft.lingering_potion.effect.turtle_master": "Brebahe perçîttente der maêttro tortuga",
  "item.minecraft.lingering_potion.effect.water": "Frâcco d'agua perçîttente",
  "item.minecraft.lingering_potion.effect.water_breathing": "Brebahe perçîttente d'ânnea",
  "item.minecraft.lingering_potion.effect.weakness": "Brebahe perçîttente de debilidá",
  "item.minecraft.lingering_potion.effect.weaving": "Brebahe perçîttente de Tehedura",
  "item.minecraft.lingering_potion.effect.wind_charged": "Poção resistênte de Carga de Vento",
  "item.minecraft.llama_spawn_egg": "Guebo heneradôh de yama",
  "item.minecraft.lodestone_compass": "Brúhula imantá",
  "item.minecraft.mace": "Maça",
  "item.minecraft.magenta_bundle": "Çaco mahenta",
  "item.minecraft.magenta_dye": "Tinte mahenta",
  "item.minecraft.magenta_harness": "Arnêh mahenta",
  "item.minecraft.magma_cream": "Crema de mâmma",
  "item.minecraft.magma_cube_spawn_egg": "Guebo heneradôh de cubo de mâmma",
  "item.minecraft.mangrove_boat": "Barca de mangle",
  "item.minecraft.mangrove_chest_boat": "Barca de mangle con baûh",
  "item.minecraft.map": "Mapa en blanco",
  "item.minecraft.melon_seeds": "Çemiyâ d'açendía",
  "item.minecraft.melon_slice": "Tahá d'açendía",
  "item.minecraft.milk_bucket": "Barde de lexe",
  "item.minecraft.minecart": "Bagoneta",
  "item.minecraft.miner_pottery_shard": "Frâmmento de çerámica de Êppioxa",
  "item.minecraft.miner_pottery_sherd": "Frâmmento de çerámica de Êppioxa",
  "item.minecraft.mojang_banner_pattern": "Patrón d'êttandarte",
  "item.minecraft.mojang_banner_pattern.desc": "Êttampao de Mojang",
  "item.minecraft.mojang_banner_pattern.new": "Etampâo de la côça",
  "item.minecraft.mooshroom_spawn_egg": "Guebo heneradôh de bacaçeta",
  "item.minecraft.mourner_pottery_shard": "Frâmmento de çerámica de warden",
  "item.minecraft.mourner_pottery_sherd": "Frâmmento de çerámica de guarden",
  "item.minecraft.mule_spawn_egg": "Guebo heneradôh de mula",
  "item.minecraft.mushroom_stew": "Giço de gurumelô",
  "item.minecraft.music_disc_11": "Dîcco de múçica",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Dîcco de múçica",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Dîcco de múçica",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Dîcco de múçica",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Dîcco de múçica",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Dîcco de múçica",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Dîcco de múçica",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Dîcco de múçica",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Crator (caha de múçica)",
  "item.minecraft.music_disc_far": "Dîcco de múçica",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Dîcco de múçica",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Dîcco de múçica",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Dîcco de múçica",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Dîcco de múçica",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Dîcco de múçica",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Dîcco de múçica",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Dîcco de múçica",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Dîcco de múçica",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Dîcco de múçica",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Dîcco de múçica",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Dîcco de múçica",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Dîcco de múçica",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Cordero crúo",
  "item.minecraft.name_tag": "Etiqueta",
  "item.minecraft.nautilus_shell": "Caparaçón de nautilo",
  "item.minecraft.nautilus_spawn_egg": "Henerâh nautilo",
  "item.minecraft.nether_brick": "Ladriyô der Nether",
  "item.minecraft.nether_star": "Êttreya der Nether",
  "item.minecraft.nether_wart": "Berruga der Nether",
  "item.minecraft.netherite_axe": "Haxa de netherita",
  "item.minecraft.netherite_boots": "Botâ de netherita",
  "item.minecraft.netherite_chestplate": "Pexera de netherita",
  "item.minecraft.netherite_helmet": "Câcco de netherita",
  "item.minecraft.netherite_hoe": "Çoleta de netherita",
  "item.minecraft.netherite_horse_armor": "Armaúra de netherita pa haca",
  "item.minecraft.netherite_ingot": "Lingote de netherita",
  "item.minecraft.netherite_leggings": "Grebâ de netherita",
  "item.minecraft.netherite_nautilus_armor": "Armaúra de netherita pa nautilo",
  "item.minecraft.netherite_pickaxe": "Êppioxa de netherita",
  "item.minecraft.netherite_scrap": "Êccoria de netherita",
  "item.minecraft.netherite_shovel": "Pala de netherita",
  "item.minecraft.netherite_spear": "Lança de netherita",
  "item.minecraft.netherite_sword": "Êppá de netherita",
  "item.minecraft.netherite_upgrade_smithing_template": "morde d'errería",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Mehóâ de nezerîta",
  "item.minecraft.oak_boat": "Barca de quehigo",
  "item.minecraft.oak_chest_boat": "Barca de quehigo con baûh",
  "item.minecraft.ocelot_spawn_egg": "Guebo heneradôh d'oçelote",
  "item.minecraft.ominous_bottle": "Frâcco ominoço",
  "item.minecraft.ominous_trial_key": "Yabe de deçafío ominoça",
  "item.minecraft.orange_bundle": "Çaco narânha",
  "item.minecraft.orange_dye": "Tinte naranha",
  "item.minecraft.orange_harness": "Arnêh naranha",
  "item.minecraft.painting": "Cuadro",
  "item.minecraft.pale_oak_boat": "Barca de quehigo pálido",
  "item.minecraft.pale_oak_chest_boat": "Barca de quehigo pálido con baûh",
  "item.minecraft.panda_spawn_egg": "Guebo heneradôh de panda",
  "item.minecraft.paper": "Papêh",
  "item.minecraft.parched_spawn_egg": "Henerâh momificao",
  "item.minecraft.parrot_spawn_egg": "Guebo heneradôh de loro",
  "item.minecraft.phantom_membrane": "Membrana de fantâmma",
  "item.minecraft.phantom_spawn_egg": "Guebo heneradôh de fantâmma",
  "item.minecraft.pig_spawn_egg": "Guebo heneradôh de coxino",
  "item.minecraft.piglin_banner_pattern": "Patrón d'êttandarte",
  "item.minecraft.piglin_banner_pattern.desc": "Êttampao de hoçico",
  "item.minecraft.piglin_banner_pattern.new": "Estampao de hocico",
  "item.minecraft.piglin_brute_spawn_egg": "Guebo heneradôh de piglin bruto",
  "item.minecraft.piglin_spawn_egg": "Guebo heneradôh de piglin",
  "item.minecraft.pillager_spawn_egg": "Guebo heneradôh de çaqueadôh",
  "item.minecraft.pink_bundle": "Saco rosa",
  "item.minecraft.pink_dye": "Tinte roça",
  "item.minecraft.pink_harness": "Arnêh roça",
  "item.minecraft.pitcher_plant": "Planta odre",
  "item.minecraft.pitcher_pod": "Baina de planta odre",
  "item.minecraft.plenty_pottery_shard": "Frâmmento de çerámica de cofre",
  "item.minecraft.plenty_pottery_sherd": "Frâmmento de çerámica de cofre",
  "item.minecraft.poisonous_potato": "Papa benenoça",
  "item.minecraft.polar_bear_spawn_egg": "Guebo heneradôh d'oço polâh",
  "item.minecraft.popped_chorus_fruit": "Fruta de corus açá",
  "item.minecraft.porkchop": "Xuleta crúa",
  "item.minecraft.potato": "Papa",
  "item.minecraft.potion": "Brebahe",
  "item.minecraft.potion.effect.awkward": "Brebahe raro",
  "item.minecraft.potion.effect.empty": "Brebahe no crâtteablê",
  "item.minecraft.potion.effect.fire_resistance": "Brebahe de cuerpo înnífugo",
  "item.minecraft.potion.effect.harming": "Brebahe de daño",
  "item.minecraft.potion.effect.healing": "Brebahe de curaçión",
  "item.minecraft.potion.effect.infested": "Brebahe de infêttaçión",
  "item.minecraft.potion.effect.invisibility": "Brebahe de imbiçibilidá",
  "item.minecraft.potion.effect.leaping": "Brebahe de çarto",
  "item.minecraft.potion.effect.levitation": "Brebahe de lebitaçión",
  "item.minecraft.potion.effect.luck": "Brebahe de potra",
  "item.minecraft.potion.effect.mundane": "Brebahe mundano",
  "item.minecraft.potion.effect.night_vision": "Brebahe de biçión nôttûnna",
  "item.minecraft.potion.effect.oozing": "Brebahe de mucoçidá",
  "item.minecraft.potion.effect.poison": "Brebahe de beneno",
  "item.minecraft.potion.effect.regeneration": "Brebahe de reheneraçión",
  "item.minecraft.potion.effect.slow_falling": "Brebahe de caída lenta",
  "item.minecraft.potion.effect.slowness": "Brebahe de lentitûh",
  "item.minecraft.potion.effect.strength": "Brebahe de fuerça",
  "item.minecraft.potion.effect.swiftness": "Brebahe de rapidêh",
  "item.minecraft.potion.effect.thick": "Brebahe denço",
  "item.minecraft.potion.effect.turtle_master": "Brebahe der maêttro tortuga",
  "item.minecraft.potion.effect.water": "Frâcco d'agua",
  "item.minecraft.potion.effect.water_breathing": "Brebahe d'ânnea",
  "item.minecraft.potion.effect.weakness": "Brebahe de debilidá",
  "item.minecraft.potion.effect.weaving": "Brebahe de teheúra",
  "item.minecraft.potion.effect.wind_charged": "Brebahe de çierço",
  "item.minecraft.pottery_shard_archer": "Frâmmento de çerámica de arco",
  "item.minecraft.pottery_shard_arms_up": "Frâmmento de çerámica de monigote",
  "item.minecraft.pottery_shard_prize": "Frâmmento de çerámica de hema",
  "item.minecraft.pottery_shard_skull": "Frâmmento de çerámica de calabera",
  "item.minecraft.powder_snow_bucket": "Barde de niebe porbo",
  "item.minecraft.prismarine_crystals": "Crîttalê de prîmmarina",
  "item.minecraft.prismarine_shard": "Frâmmento de prîmmarina",
  "item.minecraft.prize_pottery_shard": "Frâmmento de çerámica de hema",
  "item.minecraft.prize_pottery_sherd": "Frâmmento de çerámica de joya",
  "item.minecraft.pufferfish": "Pêh globo",
  "item.minecraft.pufferfish_bucket": "Barde con pêh globo",
  "item.minecraft.pufferfish_spawn_egg": "Guebo heneradôh de peh globo",
  "item.minecraft.pumpkin_pie": "Tarta de calabaça",
  "item.minecraft.pumpkin_seeds": "Çemiyâ de calabaça",
  "item.minecraft.purple_bundle": "Saco morao",
  "item.minecraft.purple_dye": "Tinte morao",
  "item.minecraft.purple_harness": "Arnêh morao",
  "item.minecraft.quartz": "Cuarço der Nether",
  "item.minecraft.rabbit": "Coneho crúo",
  "item.minecraft.rabbit_foot": "Pata de coneho",
  "item.minecraft.rabbit_hide": "Peyeho de coneho",
  "item.minecraft.rabbit_spawn_egg": "Guebo heneradôh de coneho",
  "item.minecraft.rabbit_stew": "Puxero con coneho",
  "item.minecraft.raiser_armor_trim_smithing_template": "morde d'errería",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Diçeño d'amadúrah d'elebaçión",
  "item.minecraft.ravager_spawn_egg": "Guebo heneradôh de debâttadôh",
  "item.minecraft.raw_copper": "Minerâh de cobre",
  "item.minecraft.raw_gold": "Minerâh d'oro",
  "item.minecraft.raw_iron": "Minerâh de yerro",
  "item.minecraft.recovery_compass": "Brúhula de recuperaçión",
  "item.minecraft.red_bundle": "Çaco colorao",
  "item.minecraft.red_dye": "Tinte colorao",
  "item.minecraft.red_harness": "Arnêh roho",
  "item.minecraft.redstone": "Porbo de redstone",
  "item.minecraft.resin_brick": "Bloquêh de reçina",
  "item.minecraft.resin_clump": "Grûmo deh reçina",
  "item.minecraft.rib_armor_trim_smithing_template": "Morde d'errería",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Diçeño d'amadúrah de cottîyah",
  "item.minecraft.rotten_flesh": "Cânne podría",
  "item.minecraft.saddle": "Siya de montâh",
  "item.minecraft.salmon": "Çarmón crúo",
  "item.minecraft.salmon_bucket": "Barde con çarmón",
  "item.minecraft.salmon_spawn_egg": "Guebo heneradôh de çarmón",
  "item.minecraft.scrape_pottery_sherd": "Frâmmento de çerámica de axa",
  "item.minecraft.scute": "Êccama de tortuga",
  "item.minecraft.sentry_armor_trim_smithing_template": "Morde d'errería",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Diseño de armadura de centinela",
  "item.minecraft.shaper_armor_trim_smithing_template": "Morde d'errería",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Diçeño d'armadura de modeladôh",
  "item.minecraft.sheaf_pottery_shard": "Frâmmento de çerámica de paha",
  "item.minecraft.sheaf_pottery_sherd": "Frâmmento de çerámica de tigo",
  "item.minecraft.shears": "Êttiherâ",
  "item.minecraft.sheep_spawn_egg": "Guebo heneradôh d'obeha",
  "item.minecraft.shelter_pottery_shard": "Frâmmento de çerámica de refuhio",
  "item.minecraft.shelter_pottery_sherd": "Frâmmento de çerámica de refujio",
  "item.minecraft.shield": "Êccúo",
  "item.minecraft.shield.black": "Êccúo êccuro",
  "item.minecraft.shield.blue": "Êccúo açûh",
  "item.minecraft.shield.brown": "Êccúo marrón",
  "item.minecraft.shield.cyan": "Êccúo çian",
  "item.minecraft.shield.gray": "Êccúo grîh",
  "item.minecraft.shield.green": "Êccúo berde",
  "item.minecraft.shield.light_blue": "Êccúo açûh claro",
  "item.minecraft.shield.light_gray": "Êccúo grîh claro",
  "item.minecraft.shield.lime": "Êccúo lima",
  "item.minecraft.shield.magenta": "Êccúo mahenta",
  "item.minecraft.shield.orange": "Êccúo naranha",
  "item.minecraft.shield.pink": "Êccúo roça",
  "item.minecraft.shield.purple": "Êccúo morao",
  "item.minecraft.shield.red": "Êccúo colorao",
  "item.minecraft.shield.white": "Êccúo blanco",
  "item.minecraft.shield.yellow": "Êccúo amariyo",
  "item.minecraft.shulker_shell": "Caparaçón de shulker",
  "item.minecraft.shulker_spawn_egg": "Guebo heneradôh de shulker",
  "item.minecraft.sign": "Letrero",
  "item.minecraft.silence_armor_trim_smithing_template": "morde d'errería",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Diseño de armadura de silencio",
  "item.minecraft.silverfish_spawn_egg": "Guebo heneradôh de lepîmma",
  "item.minecraft.skeleton_horse_spawn_egg": "Guebo heneradôh de haca canina",
  "item.minecraft.skeleton_spawn_egg": "Guebo heneradôh de canina",
  "item.minecraft.skull_banner_pattern": "Patrón d'êttandarte",
  "item.minecraft.skull_banner_pattern.desc": "Êttampao de calabera",
  "item.minecraft.skull_banner_pattern.new": "Estampado de calavera",
  "item.minecraft.skull_pottery_shard": "Frâmmento de çerámica de calabera",
  "item.minecraft.skull_pottery_sherd": "Frâmmento de çerámica de calabera",
  "item.minecraft.slime_ball": "Bola de limo",
  "item.minecraft.slime_spawn_egg": "Guebo heneradôh de limo",
  "item.minecraft.smithing_template": "morde d'errería",
  "item.minecraft.smithing_template.applies_to": "Ç'aplica a:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Añade un lingote o crîttâh",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Armaúra",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Añahe una pieça he armadura",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Lingotê y crîttalê",
  "item.minecraft.smithing_template.ingredients": "Ingredientêh:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Añade un lingote de netherita",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Equipamiento de diamante",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Añade una armadura, arma o erramienta de diamante",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Lingote de netherita",
  "item.minecraft.smithing_template.upgrade": "Mehora: ",
  "item.minecraft.sniffer_spawn_egg": "Guebo heneradôh d'olîqqueadôh",
  "item.minecraft.snort_pottery_shard": "Frâmmento de çerámica de snîffêh",
  "item.minecraft.snort_pottery_sherd": "Frâmmento de çerámica de snîffêh",
  "item.minecraft.snout_armor_trim_smithing_template": "morde d'errería",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Diseño de armadura de hocico",
  "item.minecraft.snow_golem_spawn_egg": "Guebo heneradôh de gólem de niebe",
  "item.minecraft.snowball": "Bola de niebe",
  "item.minecraft.spectral_arrow": "Flexa êppêttrâh",
  "item.minecraft.spider_eye": "Oho d'araña",
  "item.minecraft.spider_spawn_egg": "Guebo heneradôh d'araña",
  "item.minecraft.spire_armor_trim_smithing_template": "morde d'errería",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Diseño de armadura de agujas",
  "item.minecraft.splash_potion": "Brebahe lançable",
  "item.minecraft.splash_potion.effect.awkward": "Brebahe raro lançable",
  "item.minecraft.splash_potion.effect.empty": "Brebahe lançable no crâtteablê",
  "item.minecraft.splash_potion.effect.fire_resistance": "Brebahe lançable de cuerpo înnífugo",
  "item.minecraft.splash_potion.effect.harming": "Brebahe lançable de daño",
  "item.minecraft.splash_potion.effect.healing": "Brebahe lançable de curaçión",
  "item.minecraft.splash_potion.effect.infested": "Brebahe de infêttaçión arrohaíça",
  "item.minecraft.splash_potion.effect.invisibility": "Brebahe lançable de imbiçibilidá",
  "item.minecraft.splash_potion.effect.leaping": "Brebahe lançable de çarto",
  "item.minecraft.splash_potion.effect.levitation": "Brebahe lançable de lebitaçión",
  "item.minecraft.splash_potion.effect.luck": "Brebahe lançable de potra",
  "item.minecraft.splash_potion.effect.mundane": "Brebahe mundano lançable",
  "item.minecraft.splash_potion.effect.night_vision": "Brebahe lançable de biçión nôttûnna",
  "item.minecraft.splash_potion.effect.oozing": "Brebahe de mucoçidá arrohaíça",
  "item.minecraft.splash_potion.effect.poison": "Brebahe lançable de beneno",
  "item.minecraft.splash_potion.effect.regeneration": "Brebahe lançable de reheneraçión",
  "item.minecraft.splash_potion.effect.slow_falling": "Brebahe lançable de caída lenta",
  "item.minecraft.splash_potion.effect.slowness": "Brebahe lançable de lentitûh",
  "item.minecraft.splash_potion.effect.strength": "Brebahe lançable de fuerça",
  "item.minecraft.splash_potion.effect.swiftness": "Brebahe lançable de rapidêh",
  "item.minecraft.splash_potion.effect.thick": "Brebahe denço lançable",
  "item.minecraft.splash_potion.effect.turtle_master": "Brebahe lançable der maêttro tortuga",
  "item.minecraft.splash_potion.effect.water": "Frâcco d'agua lançable",
  "item.minecraft.splash_potion.effect.water_breathing": "Brebahe lançable d'ânnea",
  "item.minecraft.splash_potion.effect.weakness": "Brebahe lançable de debilidá",
  "item.minecraft.splash_potion.effect.weaving": "Poçión de teheúra arrohaíça",
  "item.minecraft.splash_potion.effect.wind_charged": "Brebahe de çierço arrohaíça",
  "item.minecraft.spruce_boat": "Barca de pinçapo",
  "item.minecraft.spruce_chest_boat": "Barca de pinçapo con baûh",
  "item.minecraft.spyglass": "Cataleho",
  "item.minecraft.squid_spawn_egg": "Guebo heneradôh de xoco",
  "item.minecraft.stick": "Tarama",
  "item.minecraft.stone_axe": "Haxa de piedra",
  "item.minecraft.stone_hoe": "Çoleta de piedra",
  "item.minecraft.stone_pickaxe": "Êppioxa de piedra",
  "item.minecraft.stone_shovel": "Pala de piedra",
  "item.minecraft.stone_spear": "Lança de piedra",
  "item.minecraft.stone_sword": "Êppá de piedra",
  "item.minecraft.stray_spawn_egg": "Guebo heneradôh d'errante",
  "item.minecraft.strider_spawn_egg": "Guebo heneradôh de Strider",
  "item.minecraft.string": "Cordêh",
  "item.minecraft.sugar": "Açúcâ",
  "item.minecraft.suspicious_stew": "Potahe çôppexoço",
  "item.minecraft.sweet_berries": "Bayâ durçê",
  "item.minecraft.tadpole_bucket": "Barde con guçarapo",
  "item.minecraft.tadpole_spawn_egg": "Guebo heneradôh de guçarapo",
  "item.minecraft.tide_armor_trim_smithing_template": "morde d'errería",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Diseño de armadura de la marea",
  "item.minecraft.tipped_arrow": "Flexa con efêtto",
  "item.minecraft.tipped_arrow.effect.awkward": "Flexa con efêtto",
  "item.minecraft.tipped_arrow.effect.empty": "Flexa con efêtto no crâtteablê",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Flexa de reçîttençia ar fuego",
  "item.minecraft.tipped_arrow.effect.harming": "Flexa de daño",
  "item.minecraft.tipped_arrow.effect.healing": "Flexa de curaçión",
  "item.minecraft.tipped_arrow.effect.infested": "Flexa d'infêttaçión",
  "item.minecraft.tipped_arrow.effect.invisibility": "Flexa d'imbiçibiliá",
  "item.minecraft.tipped_arrow.effect.leaping": "Flexa de çarto",
  "item.minecraft.tipped_arrow.effect.levitation": "Flexa de lebitaçión",
  "item.minecraft.tipped_arrow.effect.luck": "Flexa de potra",
  "item.minecraft.tipped_arrow.effect.mundane": "Flexa con efêtto",
  "item.minecraft.tipped_arrow.effect.night_vision": "Flexa de biçión nôttûnna",
  "item.minecraft.tipped_arrow.effect.oozing": "Flexa de mucoçidá",
  "item.minecraft.tipped_arrow.effect.poison": "Flexa de beneno",
  "item.minecraft.tipped_arrow.effect.regeneration": "Flexa de reheneraçión",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Flexa de caída lenta",
  "item.minecraft.tipped_arrow.effect.slowness": "Flexa de lentitûh",
  "item.minecraft.tipped_arrow.effect.strength": "Flexa de fuerça",
  "item.minecraft.tipped_arrow.effect.swiftness": "Flexa de rapidêh",
  "item.minecraft.tipped_arrow.effect.thick": "Flexa con efêtto",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Flexa der maêttro tortuga",
  "item.minecraft.tipped_arrow.effect.water": "Flexa de çarpicaúra",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Flexa d'ânnea",
  "item.minecraft.tipped_arrow.effect.weakness": "Flexa de debilidá",
  "item.minecraft.tipped_arrow.effect.weaving": "Flexa de teheúra",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Flexa de çierço",
  "item.minecraft.tnt_minecart": "Bagoneta con TNT",
  "item.minecraft.torchflower_seeds": "Çemiyâ de plantorxa",
  "item.minecraft.totem_of_undying": "Tótem d'îmmortalidá",
  "item.minecraft.trader_llama_spawn_egg": "Guebo heneradôh de yama ambulante",
  "item.minecraft.trial_key": "Yabe de deçafío",
  "item.minecraft.trident": "Tridente",
  "item.minecraft.tropical_fish": "Pêh tropicâh",
  "item.minecraft.tropical_fish_bucket": "Barde con pêh tropicâh",
  "item.minecraft.tropical_fish_spawn_egg": "Guebo heneradôh de pêh tropicâh",
  "item.minecraft.turtle_helmet": "Caparaçón de tortuga",
  "item.minecraft.turtle_scute": "Êccama de tortuga",
  "item.minecraft.turtle_spawn_egg": "Guebo heneradôh de tortuga",
  "item.minecraft.vex_armor_trim_smithing_template": "Morde de errería",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Diseño de armadura de vex",
  "item.minecraft.vex_spawn_egg": "Guebo heneradôh d'êppíritu",
  "item.minecraft.villager_spawn_egg": "Guebo heneradôh d'ardeano",
  "item.minecraft.vindicator_spawn_egg": "Guebo heneradôh de bindicadôh",
  "item.minecraft.wandering_trader_spawn_egg": "Guebo heneradôh de bendedôh ambulante",
  "item.minecraft.ward_armor_trim_smithing_template": "morde d'errería",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Diseño de armadura de warden",
  "item.minecraft.warden_spawn_egg": "Guebo heneradôh de cûttodio",
  "item.minecraft.warped_fungus_on_a_stick": "Hongo êttrambótico n'una caña",
  "item.minecraft.water_bucket": "Barde d'agua",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Morde d'errería",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Diseño de armadura de buscacaminos",
  "item.minecraft.wheat": "Trigo",
  "item.minecraft.wheat_seeds": "Çemiyâ de trigo",
  "item.minecraft.white_bundle": "Çaco blânco",
  "item.minecraft.white_dye": "Tinte blanco",
  "item.minecraft.white_harness": "Arnêh blanco",
  "item.minecraft.wild_armor_trim_smithing_template": "Morde d'errería",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Diseño de armadura salvaje",
  "item.minecraft.wind_charge": "Carga de biento",
  "item.minecraft.witch_spawn_egg": "Guebo heneradôh de bruha",
  "item.minecraft.wither_skeleton_spawn_egg": "Guebo heneradôh de canina der Wither",
  "item.minecraft.wither_spawn_egg": "Guebo heneradôh de Wither",
  "item.minecraft.wolf_armor": "Armaúra pa lobo",
  "item.minecraft.wolf_spawn_egg": "Guebo heneradôh de lobo",
  "item.minecraft.wooden_axe": "Haxa de maera",
  "item.minecraft.wooden_hoe": "Çoleta de maera",
  "item.minecraft.wooden_pickaxe": "Êppioxa de maera",
  "item.minecraft.wooden_shovel": "Pala de maera",
  "item.minecraft.wooden_spear": "Lança de maera",
  "item.minecraft.wooden_sword": "Êppá de maera",
  "item.minecraft.writable_book": "Libro y pluma",
  "item.minecraft.written_book": "Libro êccrito",
  "item.minecraft.yellow_bundle": "Çaco amarîyo",
  "item.minecraft.yellow_dye": "Tinte amariyo",
  "item.minecraft.yellow_harness": "Arnêh amariyo",
  "item.minecraft.zoglin_spawn_egg": "Guebo heneradôh de zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Guebo heneradôh de haca çombi",
  "item.minecraft.zombie_nautilus_spawn_egg": "Henerâh nautilo çombi",
  "item.minecraft.zombie_spawn_egg": "Guebo heneradôh de çombi",
  "item.minecraft.zombie_villager_spawn_egg": "Guebo heneradôh d'ardeano çombi",
  "item.minecraft.zombified_piglin_spawn_egg": "Guebo heneradôh de piglin çombificao"
}
export const esan = items; 
